import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import isNull from '../../../../../utils/NullChecking';
import DatePicker from '../../../../General/DatePicker';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../utils/ServerDataRequest';
import Loader from '../../../../shared/Loader/Loader';
import { useSelector } from 'react-redux';
import { convertDateToYYYYMMDD, TotalTimeArray } from '../../../../../utils/Constants';
import CalendaRangeInput from '../../../../General/CalendarRangeInput';
import InitialLetters from '../../../../../utils/InitialLetters';
import { isFemale, isMale } from '../../../../../utils/Gender';
import SuperSearchList from '../../../../shared/SuperSearch/SuperSearchList';
import FormValidator from '../../../../../utils/FormValidator';
import DeleteConfirmatiom from '../../../../General/DeleteConfirmation';
import MissedVisitPopup from '../AddMissedVisitPopup/AddMissedVisitPopup';
import AddMissedVisitPopup from '../AddMissedVisitPopup/AddMissedVisitPopup';
import moment from 'moment';
const AddMasterWeek = (props) => {

    const { isMasterWeekOpen, onClose, ID, InvalidApi } = { ...props }
    const API_URL = enumUtil.controller.AuthScheduler
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const practiceType = DropDowns.PracticeType

    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    let currentDate = new Date();
    let Zone = currentDate.toString().split(' ').slice(5).join(' ')

    let Master_Week_Modal = {
        PatientAuthorizationID: '',
        SchedulePeriod: 'One Week',
        ProcedureCodeID: '',
        isSplitShift: false,
        DateFrom: null,
        DateTo: null,
    }

    let Master_Week_Schedule = {
        "Auth": {
            "PatientID": PateintIDR,
            "PatientAuthorizationID": "",
            "isSplitShift": false,
            "Mon": "",
            "MonStartTime": "",
            "MonEndTime": "",
            "MonCaregiverID": null,
            'MonCareGiver': '',
            "MonChecked": false,
            "Tue": "",
            "TueStartTime": "",
            "TueEndTime": "",
            "TueCaregiverID": null,
            "TueCareGiver": "",
            "TueChecked": false,
            "Wed": "",
            "WedStartTime": "",
            "WedEndTime": "",
            "WedCaregiverID": null,
            "WedCareGiver": "",
            "WedChecked": false,
            "Thu": "",
            "ThuStartTime": "",
            "ThuEndTime": "",
            "ThuCaregiverID": null,
            "ThuCareGiver": "",
            "ThuChecked": false,
            "Fri": "",
            "FriStartTime": "",
            "FriEndTime": "",
            "FriCaregiverID": null,
            'FriCareGiver': "",
            "FriChecked": false,
            "Sat": "",
            "SatStartTime": "",
            "SatEndTime": "",
            "SatCaregiverID": null,
            "SatCareGiver": "",
            "SatChecked": false,
            "Sun": "",
            "SunStartTime": "",
            "SunEndTime": "",
            "SunCaregiverID": null,
            "SunCareGiver": "",
            "SunChecked": false,
            "Shifts": []
        },
        "CareGiver": []
    }
    let Save_Master_Week_Schedule = {
        "Auth": {
            "PatientID": PateintIDR,
            "PatientAuthorizationID": "",
            "isSplitShift": false,
            "Mon": "",
            "MonStartTime": "",
            "MonEndTime": "",
            "MonCaregiverID": null,
            'MonCareGiver': '',
            "MonChecked": false,
            "Tue": "",
            "TueStartTime": "",
            "TueEndTime": "",
            "TueCaregiverID": null,
            "TueCareGiver": "",
            "TueChecked": false,
            "Wed": "",
            "WedStartTime": "",
            "WedEndTime": "",
            "WedCaregiverID": null,
            "WedCareGiver": "",
            "WedChecked": false,
            "Thu": "",
            "ThuStartTime": "",
            "ThuEndTime": "",
            "ThuCaregiverID": null,
            "ThuCareGiver": "",
            "ThuChecked": false,
            "Fri": "",
            "FriStartTime": "",
            "FriEndTime": "",
            "FriCaregiverID": null,
            'FriCareGiver': "",
            "FriChecked": false,
            "Sat": "",
            "SatStartTime": "",
            "SatEndTime": "",
            "SatCaregiverID": null,
            "SatCareGiver": "",
            "SatChecked": false,
            "Sun": "",
            "SunStartTime": "",
            "SunEndTime": "",
            "SunCaregiverID": null,
            "SunCareGiver": "",
            "SunChecked": false,
            "Shifts": []
        },
        "CareGiver": []
    }

    let Scheduled_Units_Modal = {
        Mon: { overScheduled: 0, underScheduled: 0, scheduled: 0 },
        Tue: { overScheduled: 0, underScheduled: 0, scheduled: 0 },
        Wed: { overScheduled: 0, underScheduled: 0, scheduled: 0 },
        Thu: { overScheduled: 0, underScheduled: 0, scheduled: 0 },
        Fri: { overScheduled: 0, underScheduled: 0, scheduled: 0 },
        Sat: { overScheduled: 0, underScheduled: 0, scheduled: 0 },
        Sun: { overScheduled: 0, underScheduled: 0, scheduled: 0 },
    }

    let Scheduled_Units_Modal_ADC_CASE = {
        Mon: { scheduled: 0 },
        Tue: { scheduled: 0 },
        Wed: { scheduled: 0 },
        Thu: { scheduled: 0 },
        Fri: { scheduled: 0 },
        Sat: { scheduled: 0 },
        Sun: { scheduled: 0 },
    }

    let Scheduled_Shifts_Units_Modal = {}

    // let Master_Week_Schedule = {
    //     "Days": [
    //         {
    //             "Name": "Monday",
    //             "StartTime": "",
    //             "EndTime": "",
    //             "Checked": false,
    //             "CareGiverID": '',
    //             "SplitShifts": [],
    //         },
    //         {
    //             "Name": "Tuesday",
    //             "StartTime": "",
    //             "EndTime": "",
    //             "Checked": false,
    //             "CareGiverID": '',
    //             "SplitShifts": []
    //         },
    //         {
    //             "Name": "Wednesday",
    //             "StartTime": "",
    //             "EndTime": "",
    //             "Checked": false,
    //             "CareGiverID": '',
    //             "SplitShifts": []
    //         },
    //         {
    //             "Name": "Thursday",
    //             "StartTime": "",
    //             "EndTime": "",
    //             "Checked": false,
    //             "CareGiverID": '',
    //             "SplitShifts": []
    //         },
    //         {
    //             "Name": "Friday",
    //             "StartTime": "",
    //             "EndTime": "",
    //             "Checked": false,
    //             "CareGiverID": '',
    //             "SplitShifts": []
    //         },
    //         {
    //             "Name": "Saturday",
    //             "StartTime": "",
    //             "EndTime": "",
    //             "Checked": false,
    //             "CareGiverID": '',
    //             "SplitShifts": []
    //         },
    //         {
    //             "Name": "Sunday",
    //             "StartTime": "",
    //             "EndTime": "",
    //             "Checked": false,
    //             "CareGiverID": '',
    //             "SplitShifts": []
    //         },
    //     ]
    // }
    let nullArray = ['0.00', '0', 0.00, 0, "", null, undefined];
    let dayInitialsArray = ['Mon', 'Tue', "Wed", "Thu", "Fri", "Sat", "Sun"];

    let Patient_Detail_Modal = {
        Age: "",
        DOB: "",
        Gender: "",
        LocationID: "",
        MedicaidNo: "",
        Name: "",
        PatientID: "",
        InsuranceID: "",
        InsuranceName: "",
        PatientInsuranceID: "",
        ProfilePictureURL: "",
    }
    const Search_Data = {
        DateFrom: '',
        DateTo: '',
    }

    let Delete_Modal = {
        "AuthorizationID": "20358",
        "MasterWeekID": "38",
        "DateFrom": "2024/10/11",
        "DateTo": "2024/10/29"
    }

    let Validation_Modal = {
        PatientAuthorizationID: '',
    }

    let valModal = {}

    let Schedule_Validation_Modal = {
        "MonStartTime": "",
        "MonEndTime": "",
        "MonCaregiverID": "",
        "TueStartTime": "",
        "TueEndTime": "",
        "TueCaregiverID": "",
        "WedStartTime": "",
        "WedEndTime": "",
        "WedCaregiverID": "",
        "ThuStartTime": "",
        "ThuEndTime": "",
        "ThuCaregiverID": "",
        "FriStartTime": "",
        "FriEndTime": "",
        "FriCaregiverID": "",
        "SatStartTime": "",
        "SatEndTime": "",
        "SatCaregiverID": "",
        "SunStartTime": "",
        "SunEndTime": "",
        "SunCaregiverID": "",
    }

    let Schedule_Val_Modal = {}

    let Schedule_Val_Shift_Modal = {}

    const [isOpenHistory, setIsOpenHistory] = useState(false);
    const [MasterWeekID, setMasterWeekID] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [mainModalMasterWeek, setMainModalMasterWeek] = useState(Master_Week_Modal);
    const [saveModalMasterWeek, setSaveModalMasterWeek] = useState({});
    const [mainModalMasterWeekSchedule, setMainModalMasterWeekSchedule] = useState(Master_Week_Schedule)
    const [saveModalMasterWeekSchedule, setSaveModalMasterWeekSchedule] = useState(Master_Week_Schedule);
    const [DeleteModal, setDeleteModal] = useState(Delete_Modal);
    const [CareGiverDD, setCareGiverDD] = useState([]);
    const [MasterWeekValidationModal, setMasterWeekValidationModal] = useState(Validation_Modal);
    const [MasterScheduleValidationModal, setMasterScheduleValidationModal] = useState(Schedule_Validation_Modal);
    const [searchParam, setSearchParam] = useState(Search_Data);
    const [PatientDetails, setPatientDetails] = useState(Patient_Detail_Modal);
    const [AuthDropDown, setAuthDropDown] = useState([]);
    const [AuthDD, setAuthDD] = useState([]);
    const [InsuranceEditable, setInsuranceEditable] = useState(false)
    const [InsuranceDropDown, setInsuranceDropDown] = useState([])
    const [dateRange, setDateRange] = useState(null);
    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [DelID, setDelID] = useState(0)
    const [masterWeekData, setMasterWeekData] = useState({});
    const [ScheduleShiftValidation, setScheduleShiftValidation] = useState({})
    const [ShowAll, setShowAll] = useState(false)
    const [DaysSelected, setDaysSelected] = useState([]);
    const [ViewMode, setViewMode] = useState(false);
    const [IsRecordExist, setIsRecordExist] = useState(false);
    const [openMissedVisit, setOpenMissedVisit] = useState(false);
    const [HistoryRecord, setHistoryRecord] = useState([]);
    const [MissedVisit, setMissedVisit] = useState(false);
    const [BillingEntityID, setBillingEntitiyID] = useState(0)
    const [isSaved, setIsSaved] = useState(false);
    const [PatientAuthID, setPatientAuthID] = useState(0);
    const [AuthSearched, setAuthSearched] = useState(false);
    const [scheduledUnits, setScheduledUnits] = useState(Scheduled_Units_Modal);
    const [scheduledUnitsADC, setScheduledUnitsADC] = useState(Scheduled_Units_Modal_ADC_CASE);
    const [scheduledShiftsUnits, setScheduledShiftsUnits] = useState(Scheduled_Shifts_Units_Modal);
    // useEffect(() => {
    //     if (!isNull(ID)) {
    //         // set
    //     }
    // }, [ID])

    const calculateTimeDifference = (startTime, endTime) => {
        // Convert time strings into Date objects
        const start = new Date(`01/01/2024 ${startTime}`);
        const end = new Date(`01/01/2024 ${endTime}`);

        // Calculate the difference in milliseconds
        let differenceInMs = end - start;

        // If the difference is negative, it means the end time is on the next day
        if (differenceInMs < 0) {
            differenceInMs += 24 * 60 * 60 * 1000; // Add 24 hours in milliseconds
        }

        // Convert milliseconds to hours
        const differenceInHours = differenceInMs / (1000 * 60 * 60);

        return differenceInHours;
    };

    const calculateScheduledUnits = (startTime, endTime, units, dayInitials, type) => {

        let modal = { ...scheduledUnits }

        if (type === "empty") {

            modal[dayInitials]['underScheduled'] = 0;
            modal[dayInitials]['overScheduled'] = 0;
            modal[dayInitials]['scheduled'] = 0;

        }

        else {

            const start = moment(startTime, "hh:mm A")
            const end = moment(endTime, "hh:mm A")
            const unitsToMinutes = units * 15;
            // Calculate the difference in hours and minutes
            const duration = moment.duration(end.diff(start))

            const hours = duration.hours()
            const minutes = duration.minutes()

            const timeDifferenceInMinutes = (hours + (minutes / 60)) * 60;

            const selectedTime = timeDifferenceInMinutes - unitsToMinutes;

            if (selectedTime < 0) {
                modal[dayInitials]['underScheduled'] = Math.abs(selectedTime / 15);
                modal[dayInitials]['overScheduled'] = 0;
                modal[dayInitials]['scheduled'] = (unitsToMinutes + selectedTime) > 0 ? Math.abs((unitsToMinutes + selectedTime) / 15) : 0;

            }
            else if (selectedTime > 0) {
                modal[dayInitials]['overScheduled'] = Math.abs(selectedTime / 15);
                modal[dayInitials]['underScheduled'] = 0;
                modal[dayInitials]['scheduled'] = Math.abs(timeDifferenceInMinutes / 15);
            }
            else if (selectedTime === 0) {
                modal[dayInitials]['scheduled'] = Math.abs(timeDifferenceInMinutes / 15);
                modal[dayInitials]['overScheduled'] = 0;
                modal[dayInitials]['underScheduled'] = 0;
            }

        }


        setScheduledUnits(modal)

    }

    const calculateScheduledUnitsAdcCase = (units, dayInitials, type) => {

        let modal = { ...scheduledUnitsADC }

        if (type === "empty") {

            modal[dayInitials]['scheduled'] = 0;

        }

        else {

            modal[dayInitials]['scheduled'] = Math.abs(units);

        }


        setScheduledUnitsADC(modal)

    }

    const calculateUnitsHours = (units, Time, dayInitials) => {

        let minutes = '';
        let hours = '';
        let startTime = Time;

        if (!isNull(units) && !isNull(startTime)) {
            minutes = units * 15;
            hours = minutes / 60;

            // Create a moment object with the current date and start time
            let time = moment(startTime, "hh:mm A");

            // Add hours (e.g., 1.5 hours)
            time.add(hours, 'hours');

            calculateScheduledUnits(Time, time.format("hh:mm A"), units, dayInitials)
            calculateScheduledUnitsAdcCase(units, dayInitials);
            return time.format("hh:mm A")
        }

    }

    const calculateScheduledShiftsUnits = (startTime, endTime, units, dayInitials, index, type) => {

        let modal = { ...scheduledShiftsUnits }

        if (modal[index] === undefined) {
            modal[index] = {
                Mon: {},
                Tue: {},
                Wed: {},
                Thu: {},
                Fri: {},
                Sat: {},
                Sun: {},
            }
        }

        if (type === "empty") {

            modal[index][dayInitials]['underScheduled'] = 0;
            modal[index][dayInitials]['overScheduled'] = 0;
            modal[index][dayInitials]['scheduled'] = 0;

        }

        else {

            const start = moment(startTime, "hh:mm A")
            const end = moment(endTime, "hh:mm A")
            const unitsToMinutes = units * 15;
            // Calculate the difference in hours and minutes
            const duration = moment.duration(end.diff(start))

            const hours = duration.hours()
            const minutes = duration.minutes()

            const timeDifferenceInMinutes = (hours + (minutes / 60)) * 60;

            const selectedTime = timeDifferenceInMinutes - unitsToMinutes;

            if (selectedTime < 0) {
                modal[index][dayInitials]['underScheduled'] = Math.abs(selectedTime / 15);
                modal[index][dayInitials]['overScheduled'] = 0;
                modal[index][dayInitials]['scheduled'] = (unitsToMinutes + selectedTime) > 0 ? Math.abs((unitsToMinutes + selectedTime) / 15) : 0;

            }
            else if (selectedTime > 0) {
                modal[index][dayInitials]['overScheduled'] = Math.abs(selectedTime / 15);
                modal[index][dayInitials]['underScheduled'] = 0;
                modal[index][dayInitials]['scheduled'] = Math.abs(timeDifferenceInMinutes / 15);
            }
            else if (selectedTime === 0) {
                modal[index][dayInitials]['scheduled'] = Math.abs(timeDifferenceInMinutes / 15);
                modal[index][dayInitials]['overScheduled'] = 0;
                modal[index][dayInitials]['underScheduled'] = 0;
            }

        }

        setScheduledShiftsUnits(modal)

    }

    const handleScheduledUnits = (modal) => {

        Object.keys(modal['Auth'])?.map((key) => {

            if (dayInitialsArray.includes(key)) {

                calculateScheduledUnits(modal['Auth'][`${key}StartTime`], modal['Auth'][`${key}EndTime`], modal['Auth'][key], key);
                calculateScheduledUnitsAdcCase(modal['Auth'][key], key);

            }

        })
    }

    /////  handle on change functions /////

    const handleInsuranceInputChange = (e) => {
        const { value } = e.target;
        setPatientDetails(prev => ({ ...prev, InsuranceName: value }));
    };

    const handleInsuranceSelected = (selectedData, name, type) => {
        let modal = { ...PatientDetails };

        if (selectedData && selectedData.value) {
            modal['PatientInsuranceID'] = selectedData.value;
            modal['InsuranceName'] = selectedData.display;
            setPatientDetails(modal);

            const DropDown = [...AuthDD];
            setAuthDropDown(() => {
                const updatedRecord = DropDown.filter((item) =>
                    parseInt(item?.PatientInsuranceID) === parseInt(selectedData.value) &&
                    !isNull(item?.ProcedureCodeID)
                );
                return updatedRecord || [];
            });
        } else {
            modal['PatientInsuranceID'] = '';
            modal['InsuranceName'] = '';
            setPatientDetails(modal);
            setAuthDropDown([]);
        }
    };

    const handleOnChangeFilters = (e) => {
        const { name, value } = e.target
        let modal = { ...mainModalMasterWeek };
        let saveModal = { ...saveModalMasterWeek };
        modal[name] = value;
        setMainModalMasterWeek(modal);
        for (let property in Master_Week_Modal) {
            if (name === property) {
                saveModal[property] = value;
            }
        }
        setSaveModalMasterWeek(saveModal);
    }
    const handleOnChangeSchedule = (e, isChecked) => {
        const { name, value, checked } = e.target

        let modal = { ...mainModalMasterWeekSchedule };
        let saveModal = { ...saveModalMasterWeekSchedule };
        if (isChecked) {
            if (!checked) {
                const endTimeKey = `${name.slice(0, 3)}EndTime`;
                const startTimeKey = `${name.slice(0, 3)}StartTime`;
                const caregiverIDKey = `${name.slice(0, 3)}CaregiverID`;
                modal['Auth'][endTimeKey] = '';
                modal['Auth'][startTimeKey] = '';
                modal['Auth'][caregiverIDKey] = '';

                EmptySubShift(name.slice(0, 3));

                calculateScheduledUnits(undefined, undefined, undefined, name.slice(0, 3), 'empty')
                calculateScheduledUnitsAdcCase(undefined, name.slice(0, 3), 'empty');

            }
            modal['Auth'][name] = checked;
        }
        else {
            if (name === `${name.slice(0, 3)}StartTime`) {
                if (!isNull(modal['Auth'][`${name.slice(0, 3)}EndTime`])) {
                    let comparison = compareTimes(value, modal['Auth'][`${name.slice(0, 3)}EndTime`])

                    if (!comparison) {
                        modal['Auth'][`${name.slice(0, 3)}EndTime`] = ''
                    }
                } else {
                    if (BillingEntityID == '2') {
                        let updatedTime = calculateUnitsHours(modal['Auth'][`${name.slice(0, 3)}`], value, name.slice(0, 3));
                        if (updatedTime) {
                            modal['Auth'][`${name.slice(0, 3)}EndTime`] = updatedTime
                        }
                    }

                }
                modal['Auth'][`${name.slice(0, 3)}Checked`] = true;

            }
            modal['Auth'][name] = value;
        }

        setMainModalMasterWeekSchedule(modal);
        for (let property in Master_Week_Schedule.Auth) {
            if (name === property) {
                if (isChecked) {
                    console.log("isChecked", isChecked)
                    if (!checked) {

                        const endTimeKey = `${name.slice(0, 3)}EndTime`;
                        const startTimeKey = `${name.slice(0, 3)}StartTime`;
                        const caregiverIDKey = `${name.slice(0, 3)}CaregiverID`;
                        saveModal['Auth'][endTimeKey] = '';
                        saveModal['Auth'][startTimeKey] = '';
                        saveModal['Auth'][caregiverIDKey] = '';

                    }
                    saveModal['Auth'][property] = checked;

                }
                else {
                    if (name === `${name.slice(0, 3)}StartTime`) {
                        if (!isNull(saveModal['Auth'][`${name.slice(0, 3)}EndTime`])) {
                            let comparison = compareTimes(value, saveModal['Auth'][`${name.slice(0, 3)}EndTime`])
                            if (!comparison) {
                                saveModal['Auth'][`${name.slice(0, 3)}EndTime`] = ''
                            }
                        }
                        saveModal['Auth'][`${name.slice(0, 3)}Checked`] = true;
                    }

                    saveModal['Auth'][property] = value;
                }

            }
        }

        setSaveModalMasterWeekSchedule(saveModal);
    }

    const handleScheduleSelectedData = (selectedData, name, type) => {

        let modal = { ...mainModalMasterWeekSchedule };
        let saveModal = { ...saveModalMasterWeekSchedule };


        if (name === `${name.slice(0, 3)}StartTime`) {

            if (!isNull(modal['Auth'][`${name.slice(0, 3)}EndTime`])) {
                let comparison = compareTimes(selectedData?.value, modal['Auth'][`${name.slice(0, 3)}EndTime`])

                if (!comparison) {
                    modal['Auth'][`${name.slice(0, 3)}EndTime`] = '';
                } else {
                    calculateScheduledUnits(selectedData?.value, modal['Auth'][`${name.slice(0, 3)}EndTime`], modal['Auth'][`${name.slice(0, 3)}`], name.slice(0, 3))
                    calculateScheduledUnitsAdcCase(modal['Auth'][`${name.slice(0, 3)}`], name.slice(0, 3));
                }


            } else {
                if (BillingEntityID == '2') {
                    let updatedTime = calculateUnitsHours(modal['Auth'][`${name.slice(0, 3)}`], selectedData?.value, name.slice(0, 3));
                    if (updatedTime) {
                        modal['Auth'][`${name.slice(0, 3)}EndTime`] = updatedTime
                    }
                    calculateScheduledUnits(selectedData?.value, modal['Auth'][`${name.slice(0, 3)}EndTime`], modal['Auth'][`${name.slice(0, 3)}`], name.slice(0, 3))
                    calculateScheduledUnitsAdcCase(modal['Auth'][`${name.slice(0, 3)}`], name.slice(0, 3));
                }
            }
            modal['Auth'][`${name.slice(0, 3)}Checked`] = true;

        }
        if (name === `${name.slice(0, 3)}EndTime`) {
            if (!isNull(modal['Auth'][`${name.slice(0, 3)}StartTime`])) {
                calculateScheduledUnits(modal['Auth'][`${name.slice(0, 3)}StartTime`], selectedData?.value, modal['Auth'][`${name.slice(0, 3)}`], name.slice(0, 3))
                calculateScheduledUnitsAdcCase(modal['Auth'][`${name.slice(0, 3)}`], name.slice(0, 3));
            }
        }
        if (name === `${name.slice(0, 3)}CaregiverID`) {
            modal['Auth'][`${name.slice(0, 3)}CareGiver`] = selectedData?.display;
        }
        modal['Auth'][name] = selectedData?.value;


        setMainModalMasterWeekSchedule(modal);
        for (let property in Master_Week_Schedule.Auth) {
            if (name === property) {


                if (name === `${name.slice(0, 3)}StartTime`) {
                    if (!isNull(saveModal['Auth'][`${name.slice(0, 3)}EndTime`])) {
                        let comparison = compareTimes(selectedData?.value, saveModal['Auth'][`${name.slice(0, 3)}EndTime`])
                        if (!comparison) {
                            saveModal['Auth'][`${name.slice(0, 3)}EndTime`] = ''
                        }
                    }
                    saveModal['Auth'][`${name.slice(0, 3)}Checked`] = true;
                }
                if (name === `${name.slice(0, 3)}CaregiverID`) {
                    saveModal['Auth'][`${name.slice(0, 3)}CareGiver`] = selectedData?.display;
                }
                saveModal['Auth'][property] = selectedData?.value;


            }
        }
        setSaveModalMasterWeekSchedule(saveModal);
    }

    const handleOnChangeScheduleShifts = (e, index, isChecked) => {

        const { name, value, checked } = e.target

        let modal = { ...mainModalMasterWeekSchedule };
        let saveModal = { ...saveModalMasterWeekSchedule };

        if (isChecked) {
            if (!checked) {
                const endTimeKey = `${name.slice(0, 3)}EndTime`;
                const startTimeKey = `${name.slice(0, 3)}StartTime`;
                const caregiverIDKey = `${name.slice(0, 3)}CaregiverID`;
                modal['Auth']['Shifts'][index][endTimeKey] = '';
                modal['Auth']['Shifts'][index][startTimeKey] = '';
                modal['Auth']['Shifts'][index][caregiverIDKey] = '';
                calculateScheduledShiftsUnits(undefined, undefined, undefined, name.slice(0, 3), index, 'empty');
            }
            modal['Auth']['Shifts'][index][name] = checked;
        }
        else {
            if (name === `${name.slice(0, 3)}StartTime`) {
                if (!isNull(modal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`])) {
                    let comparison = compareTimes(value, modal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`])

                    if (!comparison) {
                        modal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`] = ''
                    }
                }
                else {
                    if (BillingEntityID == '2') {
                        let updatedTime = calculateUnitsHours(modal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], value, name.slice(0, 3));
                        if (updatedTime) {
                            modal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`] = updatedTime
                        }

                    }

                }
                modal['Auth']['Shifts'][index][`${name.slice(0, 3)}Checked`] = true;
            }
            modal['Auth']['Shifts'][index][name] = value;
        }

        setMainModalMasterWeekSchedule(modal);
        for (let property in Master_Week_Schedule.Auth) {
            if (name === property) {
                if (isChecked) {
                    if (!checked) {
                        const endTimeKey = `${name.slice(0, 3)}EndTime`;
                        const startTimeKey = `${name.slice(0, 3)}StartTime`;
                        const caregiverIDKey = `${name.slice(0, 3)}CaregiverID`;
                        saveModal['Auth']['Shifts'][index][endTimeKey] = '';
                        saveModal['Auth']['Shifts'][index][startTimeKey] = '';
                        saveModal['Auth']['Shifts'][index][caregiverIDKey] = '';

                    }
                    saveModal['Auth']['Shifts'][index][property] = checked;
                }
                else {
                    if (name === `${name.slice(0, 3)}StartTime`) {
                        if (!isNull(saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`])) {
                            let comparison = compareTimes(value, saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`])

                            if (!comparison) {
                                saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`] = ''
                            }
                        }
                        if (BillingEntityID == '2') {
                            let updatedTime = calculateUnitsHours(saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], value, name.slice(0, 3));
                            if (updatedTime) {
                                saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`] = updatedTime
                            }

                        }
                        saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}Checked`] = true;
                    }
                    saveModal['Auth']['Shifts'][index][property] = value;
                }

            }
        }
        setSaveModalMasterWeekSchedule(saveModal);
    }

    const handleScheduleShiftsSelectedData = (selectedData, name, type, index) => {

        let modal = { ...mainModalMasterWeekSchedule };
        let saveModal = { ...saveModalMasterWeekSchedule };

        if (name === `${name.slice(0, 3)}StartTime`) {
            if (!isNull(modal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`])) {

                let comparison = compareTimes(selectedData?.value, modal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`])

                if (!comparison) {
                    modal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`] = ''
                }

                calculateScheduledShiftsUnits(selectedData?.value, modal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`], modal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], name.slice(0, 3), index)
            }
            else {
                if (BillingEntityID == '2') {
                    let updatedTime = calculateUnitsHours(modal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], selectedData?.value, name.slice(0, 3));
                    if (updatedTime) {
                        modal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`] = updatedTime
                    }
                    calculateScheduledShiftsUnits(selectedData?.value, updatedTime, modal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], name.slice(0, 3), index)

                }

            }
            modal['Auth']['Shifts'][index][`${name.slice(0, 3)}Checked`] = true;
        }
        if (name === `${name.slice(0, 3)}EndTime`) {
            if (!isNull(modal['Auth']['Shifts'][index][`${name.slice(0, 3)}StartTime`])) {
                calculateScheduledShiftsUnits(modal['Auth']['Shifts'][index][`${name.slice(0, 3)}StartTime`], selectedData?.value, modal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], name.slice(0, 3), index)
            }
        }
        if (name === `${name.slice(0, 3)}CaregiverID`) {
            modal['Auth']['Shifts'][index][`${name.slice(0, 3)}CareGiver`] = selectedData?.display;
        }
        modal['Auth']['Shifts'][index][name] = selectedData?.value;


        setMainModalMasterWeekSchedule(modal);
        for (let property in Master_Week_Schedule.Auth) {
            if (name === property) {

                if (name === `${name.slice(0, 3)}StartTime`) {
                    if (!isNull(saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`])) {
                        let comparison = compareTimes(selectedData?.value, saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`])

                        if (!comparison) {
                            saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`] = ''
                        }
                    }
                    if (BillingEntityID == '2') {
                        let updatedTime = calculateUnitsHours(saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}`], selectedData?.value, name.slice(0, 3));
                        if (updatedTime) {
                            saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}EndTime`] = updatedTime
                        }

                    }
                    saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}Checked`] = true;
                }
                if (name === `${name.slice(0, 3)}CaregiverID`) {
                    saveModal['Auth']['Shifts'][index][`${name.slice(0, 3)}CareGiver`] = selectedData?.display;
                }
                saveModal['Auth']['Shifts'][index][property] = selectedData?.value;

            }
        }

        setSaveModalMasterWeekSchedule(saveModal);
    }

    const handleChangeDD = (e) => {
        // setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainModalMasterWeek };
        let saveModal = { ...saveModalMasterWeek };
        modal[name] = value
        setMainModalMasterWeek(modal)
        for (var property in Master_Week_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setSaveModalMasterWeek(saveModal)
    }

    const handleSelectedData = (selectedData, name, type, mode) => {
        let modal = { ...mainModalMasterWeek };
        let saveModal = { ...saveModalMasterWeek };

        if (type === 'client' && !isNull(selectedData)) {

            if(name === "SchedulePeriod"){
                modal[name] = selectedData?.value;
            }
            else {
            modal[name] = selectedData?.display;
            modal['isSplitShift'] = selectedData?.isSplitShift;
            modal['ProcedureCodeID'] = selectedData?.ProcedureCodeID;
            modal['DateFrom'] = selectedData?.DateFrom;
            modal['DateTo'] = selectedData?.DateTo;

            setSearchParam({ ...searchParam, DateFrom: selectedData?.DateFrom, DateTo: selectedData?.DateTo })

            saveModal[name] = selectedData?.value + "";
            saveModal['isSplitShift'] = selectedData?.isSplitShift + "";
            saveModal['ProcedureCodeID'] = selectedData?.ProcedureCodeID;
            saveModal['DateFrom'] = selectedData?.DateFrom;
            saveModal['DateTo'] = selectedData?.DateTo;

            setPatientAuthID(selectedData?.value);
            setBillingEntitiyID(selectedData?.BillingEntityID);
            setDateRange(`${selectedData?.DateFrom + '-' + selectedData?.DateTo}`);

            setViewMode(() => {
                return selectedData?.MasterWeekEXISTS === "true" ?
                    true : false;
            })
            setIsRecordExist(() => {
                return selectedData?.MasterWeekEXISTS === "true" ?
                    true : false;
            })
        }
    }
        else {

            modal = Master_Week_Modal;
            saveModal = {};

        }
        setMainModalMasterWeek(modal);
        setSaveModalMasterWeek(saveModal);
        if (selectedData?.value != mainModalMasterWeekSchedule?.Auth?.PatientAuthorizationID) {
            setMainModalMasterWeekSchedule(Master_Week_Schedule);
            setSaveModalMasterWeekSchedule(Master_Week_Schedule);
            setScheduledUnits(Scheduled_Units_Modal);
            setScheduledUnitsADC(Scheduled_Units_Modal_ADC_CASE);
            setAuthSearched(false)
        }

        return saveModal
    }

    //// Load Data ///
    const LoadData = (searchParam) => {

        setIsLoading(true);
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.MasterWeekSchedule,
            "ID": searchParam?.PatientAuthorizationID,
            "SEARCHCRITERIA": {
                "PatientID": PateintIDR + '',
                "isSplitShift": searchParam?.isSplitShift,
            }
        }
        ServerRequestProtected(API_URL + '/FindMasterWeekINFO', 'post', saveModal)
            .then((response) => {

                setIsLoading(false);
                setMasterWeekData(response);
                setMainModalMasterWeekSchedule(response);
                setSaveModalMasterWeekSchedule(response);
                setCareGiverDD(response?.CareGiver);
                setHistoryRecord(response?.MasterWeekHistory);
                setDeleteModal({ ...DeleteModal, DateFrom: searchParam?.DateFrom + '', DateTo: searchParam?.DateTo + '', AuthorizationID: searchParam?.PatientAuthorizationID + '', MasterWeekID: response?.Auth?.MasterWeekID + "" });
                setAuthSearched(() => {
                    return searchParam?.PatientAuthorizationID === response?.Auth?.PatientAuthorizationID ? true : false;
                })
                handleScheduledUnits(response);

            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    }

    /// Validations /// 

    const formValidation = () => {
        let validationModal = {
            PatientAuthorizationID: FormValidator(mainModalMasterWeek?.PatientAuthorizationID, enumUtil.enumValidationType.Required, '')
        }
        setMasterWeekValidationModal(validationModal)
        valModal = validationModal
    }

    const formScheduleValidation = () => {
        let validationModal = {
            PatientAuthorizationID: FormValidator(mainModalMasterWeek?.PatientAuthorizationID, enumUtil.enumValidationType.Required, 'Authorization ID'),
            "MonStartTime": (mainModalMasterWeekSchedule?.['Auth']?.MonChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.MonStartTime, enumUtil.enumValidationType.Required, '')),
            "MonEndTime": (mainModalMasterWeekSchedule?.["Auth"]?.MonChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.MonEndTime, enumUtil.enumValidationType.Required, '')),
            // "MonCaregiverID": (mainModalMasterWeekSchedule?.["Auth"]?.MonChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.MonCaregiverID, enumUtil.enumValidationType.Required, '')),
            "TueStartTime": (mainModalMasterWeekSchedule?.["Auth"].TueChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.TueStartTime, enumUtil.enumValidationType.Required, '')),
            "TueEndTime": (mainModalMasterWeekSchedule?.["Auth"].TueChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.TueEndTime, enumUtil.enumValidationType.Required, '')),
            // "TueCaregiverID": (mainModalMasterWeekSchedule?.["Auth"].TueChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.TueCaregiverID, enumUtil.enumValidationType.Required, '')),
            "WedStartTime": (mainModalMasterWeekSchedule?.["Auth"].WedChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.WedStartTime, enumUtil.enumValidationType.Required, '')),
            "WedEndTime": (mainModalMasterWeekSchedule?.["Auth"].WedChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.WedEndTime, enumUtil.enumValidationType.Required, '')),
            // "WedCaregiverID": (mainModalMasterWeekSchedule?.["Auth"].WedChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.WedCaregiverID, enumUtil.enumValidationType.Required, '')),
            "ThuStartTime": (mainModalMasterWeekSchedule?.["Auth"].ThuChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.ThuStartTime, enumUtil.enumValidationType.Required, '')),
            "ThuEndTime": (mainModalMasterWeekSchedule?.["Auth"].ThuChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.ThuEndTime, enumUtil.enumValidationType.Required, '')),
            // "ThuCaregiverID": (mainModalMasterWeekSchedule?.["Auth"].ThuChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.ThuCaregiverID, enumUtil.enumValidationType.Required, '')),
            "FriStartTime": (mainModalMasterWeekSchedule?.["Auth"].FriChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.FriStartTime, enumUtil.enumValidationType.Required, '')),
            "FriEndTime": (mainModalMasterWeekSchedule?.["Auth"].FriChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.FriEndTime, enumUtil.enumValidationType.Required, '')),
            // "FriCaregiverID": (mainModalMasterWeekSchedule?.["Auth"].FriChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.FriCaregiverID, enumUtil.enumValidationType.Required, '')),
            "SatStartTime": (mainModalMasterWeekSchedule?.["Auth"].SatChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.SatStartTime, enumUtil.enumValidationType.Required, '')),
            "SatEndTime": (mainModalMasterWeekSchedule?.["Auth"].SatChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.SatEndTime, enumUtil.enumValidationType.Required, '')),
            // "SatCaregiverID": (mainModalMasterWeekSchedule?.["Auth"].SatChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.SatCaregiverID, enumUtil.enumValidationType.Required, '')),
            "SunStartTime": (mainModalMasterWeekSchedule?.["Auth"].SunChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.SunStartTime, enumUtil.enumValidationType.Required, '')),
            "SunEndTime": (mainModalMasterWeekSchedule?.["Auth"].SunChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.SunEndTime, enumUtil.enumValidationType.Required, '')),
            // "SunCaregiverID": (mainModalMasterWeekSchedule?.["Auth"].SunChecked && FormValidator(mainModalMasterWeekSchedule?.["Auth"]?.SunCaregiverID, enumUtil.enumValidationType.Required, '')),
        }
        setMasterScheduleValidationModal(validationModal)
        Schedule_Val_Modal = validationModal
    }

    const formScheduleShiftValidation = () => {
        let validationModal = []
        mainModalMasterWeekSchedule?.Auth?.Shifts?.forEach((shift, index) => {
            validationModal[index] = {};
            Object.keys(shift)?.map((key) => {

                const endTimeKey = `${key.slice(0, 3)}EndTime`;
                const startTimeKey = `${key.slice(0, 3)}StartTime`;
                const caregiverIDKey = `${key.slice(0, 3)}CaregiverID`;

                if (key?.includes('Checked') && mainModalMasterWeekSchedule?.Auth?.[key] && shift[key]) {

                    validationModal[index][endTimeKey] = FormValidator(shift[endTimeKey], enumUtil.enumValidationType.Required, '')
                    validationModal[index][startTimeKey] = FormValidator(shift[startTimeKey], enumUtil.enumValidationType.Required, '')
                    // validationModal[index][caregiverIDKey] = FormValidator(shift[caregiverIDKey], enumUtil.enumValidationType.Required, '')
                }
            })

            // if(Object.keys(shift)){
            //     .includes('CaregiverID') && shift[]
            // }
        })

        setScheduleShiftValidation(validationModal);
        Schedule_Val_Shift_Modal = validationModal
    }

    /// functionalities ///

    const PropertyNullCheck = (modal) => {
        Object.keys(modal).forEach((key) => {
            if (key.includes("CaregiverID") && (modal[key] === "" || modal[key] === "-1")) {

                modal[key] = IsRecordExist ? "-99" : null;
            }
        })

        modal.Shifts.forEach((item) => {
            Object.keys(item).forEach((key) => {
                if (key.includes("CaregiverID") && (item[key] === "" || modal[key] === "-1")) {
                    item[key] = IsRecordExist ? "-99" : null;
                }
            })
        })

        return modal;
    }

    const handleCareGiverByDefault = (modal, obj, type) => {

        Object.keys(modal).map((item) => {
            if (item.includes('CaregiverID')) {
                modal[item] = obj?.value;
                modal[`${item.slice(0, 3)}CareGiver`] = obj?.display;
            }
        })

        modal?.Shifts?.map((Shift) => {
            Object.keys(Shift).map((item) => {
                if (item.includes('CaregiverID')) {
                    Shift[item] = obj?.value;
                    Shift[`${item.slice(0, 3)}CareGiver`] = obj?.display;
                }
            })
        })

        return modal
    }

    function getDaysBetween(startDate, endDate) {
        const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Calculate the difference in days
        const differenceInTime = end.getTime() - start.getTime();
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);

        // Check if the difference is less than or equal to 7 days
        if (differenceInDays <= 6) {
            const daysBetween = [];

            for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
                const dayName = dayNames[d.getDay()];  // Get the day name
                const dayNumber = d.getDate();         // Get the day number
                daysBetween.push({ dayName, dayNumber });
            }

            return daysBetween;
        } else {
            return [];
        }
    }

    const handleEditMode = (e) => {
        setViewMode(!ViewMode);
    }

    function convertTo24Hour(time) {

        const [timePart, modifier] = time.split(" ");
        let [hours, minutes] = timePart.split(":").map(Number);

        if (modifier === "PM" && hours !== 12) {
            hours += 12;
        }
        if (modifier === "AM" && hours === 12) {
            hours = 0;
        }

        return { hours, minutes };
    }

    function compareTimes(time1, time2) {
        if (!isNull(time1)) {

            const time1Obj = convertTo24Hour(time1);
            const time2Obj = convertTo24Hour(time2);

            const date1 = new Date();
            const date2 = new Date();

            date1.setHours(time1Obj.hours, time1Obj.minutes);
            date2.setHours(time2Obj.hours, time2Obj.minutes);

            // Compare times
            if (date2.getTime() > date1.getTime()) {
                return time2;
            }

        }
        else {
            return time2
        }
    }

    const FormValidationScheduleChecked = (list) => {

        let result = []
        if (list) {
            list.map((item) => {
                Object.keys(item)?.map((key) => {
                    if (key.includes('Checked')) {
                        if (item[key]) {
                            let obj = { [key]: item[key] }
                            result.push(obj);
                        }
                    }
                })
            })
        }
        return result?.length > 0 ? false : true;

    }

    const FormValidatorArray = (list) => {
        let result = false
        if (list && list.length > 0) {
            list.map((item) => {
                Object.keys(item)?.map((key) => {
                    if (!isNull(item[key])) {
                        result = true
                    }
                })
            })
        }
        return result
    }

    const EmptySubShift = (dayName) => {
        mainModalMasterWeekSchedule?.Auth?.Shifts?.forEach((shift, index) => {
            shift[`${dayName}Checked`] = false;
            shift[`${dayName}StartTime`] = '';
            shift[`${dayName}EndTime`] = '';
            shift[`${dayName}CaregiverID`] = '';
        })
        saveModalMasterWeekSchedule?.Auth?.Shifts?.forEach((shift, index) => {
            shift[`${dayName}Checked`] = false;
            shift[`${dayName}StartTime`] = '';
            shift[`${dayName}EndTime`] = '';
            shift[`${dayName}CaregiverID`] = '';
        })
    }

    const handleTimeInADC = (e, startTime, endTime) => {

        let modal = JSON.parse(JSON.stringify(mainModalMasterWeekSchedule));
        let saveModal = JSON.parse(JSON.stringify(saveModalMasterWeekSchedule));


        Object.keys(modal.Auth).forEach((key) => {

            if (!nullArray.includes(modal['Auth'][`${key.slice(0, 3)}`])) {
                if (key.includes('StartTime')) {
                    modal['Auth'][key] = startTime;
                }
                if (key.includes('EndTime')) {
                    modal['Auth'][key] = endTime;
                }
                if (key.includes('Checked')) {
                    modal['Auth'][key] = true;
                }
                if (key === key.slice(0, 3)) {
                    calculateScheduledUnits(startTime, endTime, modal['Auth'][`${key.slice(0, 3)}`], key.slice(0, 3))
                    calculateScheduledUnitsAdcCase(modal['Auth'][`${key.slice(0, 3)}`], key.slice(0, 3));
                }
            }
        })
        setMainModalMasterWeekSchedule(modal);

        Object.keys(saveModal.Auth).forEach((key) => {

            let initials = key.slice(0, 3);

            let daySelected = DaysSelected.length > 0 ? DaysSelected.some((dayOBj) => {
                const dayInitials = dayOBj?.dayName.slice(0, 3);
                return dayInitials === initials;
            }) : true;


            if (!nullArray.includes(saveModal['Auth'][`${key.slice(0, 3)}`]) && daySelected) {

                if (key.includes('StartTime')) {
                    saveModal['Auth'][key] = startTime;
                }
                if (key.includes('EndTime')) {
                    saveModal['Auth'][key] = endTime;
                }
                if (key.includes('Checked')) {
                    saveModal['Auth'][key] = true;
                }
            }
        })

        setSaveModalMasterWeekSchedule(saveModal);

    }

    /// Save Modal ///
    const handleSaveMasterWeek = () => {
        let udatedSaveModal = PropertyNullCheck(saveModalMasterWeekSchedule?.Auth)

        // saveModalMasterWeekSchedule['Auth']['PatientAuthorizationID'] = saveModalMasterWeek['PatientAuthorizationID'];
        // saveModalMasterWeekSchedule['Auth']['isSplitShift'] = saveModalMasterWeek['isSplitShift'];

        formValidation()

        if (practiceType !== "Adult Day Care") {
            formScheduleValidation()
            formScheduleShiftValidation()
        }

        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck);
        let validationSchedule = FormValidator([Schedule_Val_Modal], enumUtil.enumValidationType.NullCheck);
        let validationScheduleChecked = FormValidationScheduleChecked([{ ...saveModalMasterWeekSchedule?.Auth }]);
        let validationScheduleShift = FormValidatorArray(Schedule_Val_Shift_Modal);

        if (validation || validationSchedule || validationScheduleShift || validationScheduleChecked) {

            return
        }
        else {

            setIsLoading(true)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.MasterWeekSchedule,
                "DateFrom": convertDateToYYYYMMDD(mainModalMasterWeek?.DateFrom),
                "DateTo": convertDateToYYYYMMDD(mainModalMasterWeek?.DateTo),
                "ProcedureID": mainModalMasterWeek?.ProcedureCodeID,
                "AuthorizationID": saveModalMasterWeek['PatientAuthorizationID'],
                "PatientID": PatientDetails?.PatientID + '',
                "LocationID": PatientDetails?.LocationID + '',
                "InsuranceID": PatientDetails?.InsuranceID + '',
                "PatientInsuranceID": PatientDetails?.PatientInsuranceID + '',
                "Zone": Zone,
                "MasterWeekDetails": [
                    { ...udatedSaveModal }
                ],
            }
            ServerRequestProtected(API_URL + '/SaveMasterWeekSchedule', 'post', saveModal).then((response) => {
                setIsLoading(false);
                setIsSaved(true)
                NotificationHandler("Record Saved Successfully", enumUtil.enumtoaster.success)
            }).catch((error) => {
                setIsLoading(false)
                setIsSaved(false)
                NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error)
            })
        }
    }

    const handleDelete = (ID) => {
        setDelID(ID);
        setIsOpenAlert(true);
    }

    const onCloseDelete = () => {
        setIsOpenAlert(false);
    }

    const onCloseOnDelete = () => {
        setIsOpenAlert(false);
        LoadData(saveModalMasterWeek);
    }

    let DeleteConfirmation = '';
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseOnDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.MasterWeekSchedule} onClose={onCloseDelete} type={"DeleteMasterWeek"} payload={DeleteModal} Messsage={true} hideReason={true} />
    }

    const handleMissedVisit = (e) => {
        const { name, value, checked } = e.target;
        setMissedVisit(checked)

        if (checked) {
            setOpenMissedVisit(true)
        }
    }

    const onCloseMissedPopup = () => {
        setOpenMissedVisit(false)
    }

    const onCloseSaveMissedPopup = () => {
        setOpenMissedVisit(false)
    }

    let MissedVisitPopup = "";
    if (openMissedVisit) {
        MissedVisitPopup = <AddMissedVisitPopup openPopup={openMissedVisit} onClose={onCloseMissedPopup} onCloseSave={onCloseSaveMissedPopup} />
    }

    const onCloseSave = () => {
        InvalidApi()
        onClose()
    }
    // useEffect(() => {
    //     if (mainModalMasterWeek?.PatientAuthorizationID) {
    //         LoadData()

    //     }
    // }, [mainModalMasterWeek?.PatientAuthorizationID])

    /// useEffects ///

    useEffect(() => {
        if (!isNull(PateintIDR)) {
            setAuthDropDown([]);
            setInsuranceDropDown([])
            setPatientDetails({});
            setMasterWeekID(PateintIDR);
            setIsLoading(true);
            ServerRequestProtected(API_URL + "/PatientAuthDropDown", 'post', {

                "ID": PateintIDR,
                "TableName": enumUtil.enumAPITableName.MasterWeekSchedule,

            }).then((response) => {

                let patientDetails = response?.PatientDetails;
                let AuthDD = response?.PatientAuthDetails;
                let InsuranceDD = response?.InsuranceINFO;

                setAuthDD(AuthDD ? AuthDD.filter((item) => {
                    return !isNull(item?.PatientInsuranceID);
                }) : []);

                setAuthDropDown(AuthDD ? AuthDD.filter((item) => {
                    return parseInt(item?.PatientInsuranceID) === parseInt(response?.PatientDetails?.PatientInsuranceID) && !isNull(item?.ProcedureCodeID);
                }) : []);

                setPatientDetails(patientDetails ? patientDetails : {});
                setInsuranceDropDown(InsuranceDD ? InsuranceDD : []);
                setIsLoading(false);

            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            });
        }
    }, [PateintIDR]);


    useEffect(() => {
        let days = []
        days = getDaysBetween(mainModalMasterWeek?.DateFrom, mainModalMasterWeek?.DateTo)
        if (days.length > 7 || days.length === 0) {
            setShowAll(true);
            setDaysSelected([]);
        } else {
            setShowAll(false);
            setDaysSelected(days);
        }

    }, [mainModalMasterWeek?.DateFrom, mainModalMasterWeek?.DateTo])

    useEffect(() => {

        if (AuthDropDown?.length === 1) {
            setPatientAuthID(AuthDropDown[0]?.value);
            let updatedSaveModal = handleSelectedData(AuthDropDown[0], 'PatientAuthorizationID', 'client');

            LoadData(updatedSaveModal);
        } else {
            setMainModalMasterWeek({ ...mainModalMasterWeek, PatientAuthorizationID: '' })
            setSaveModalMasterWeek({ ...saveModalMasterWeek, PatientAuthorizationID: '' })
        }
    }, [AuthDropDown])

    useEffect(() => {
        if (CareGiverDD?.length === 2) {

            let modal = handleCareGiverByDefault(mainModalMasterWeekSchedule?.Auth, CareGiverDD[1], 'main')
            let saveModal = handleCareGiverByDefault(saveModalMasterWeekSchedule?.Auth, CareGiverDD[1], 'save')

            setMainModalMasterWeekSchedule({ ...mainModalMasterWeekSchedule, Auth: modal });
            setSaveModalMasterWeekSchedule({ ...saveModalMasterWeekSchedule, Auth: saveModal });
        }
    }, [CareGiverDD])

    return (

        <Modal show={isMasterWeekOpen} onHide={isMasterWeekOpen} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 provider_schedular za-create_master_weekpopup">
            <Modal.Body>
                {DeleteConfirmation}
                {MissedVisitPopup}
                {isLoading ? <Loader /> : <></>}
                <div className='d-flex justify-content-between align-items-center mb-10 px-10' >
                    <p></p>
                    <div className='heading fs-14 dark-clr'>Add Master Week</div>
                    <div className='d-flex align-items-center gap-2'>
                        <div className='za-tooltip position-relative '>
                            <i className='icon-Icon-material-timelapse' onClick={() => setIsOpenHistory(!isOpenHistory)}></i>
                            {isOpenHistory &&
                                <div className='d-flex flex-column gap-10 ar-br-bottom'>
                                    <div className='za-history-popup position-absolute'>
                                        <p className='heading fs-11'>History</p>
                                        <div className='history_content hover-scrollbar'>
                                            {HistoryRecord?.map((item) => {
                                                return (
                                                    <>

                                                        <div className='d-flex flex-column gap-10 mt-12 ar-br-bottom'>
                                                            <div className='d-flex gap-1 align-items-center'>
                                                                <p className='text font-m fs-10'>Applied Date Range :</p>
                                                                <p className='text fs-10'>{item?.DOS}</p>
                                                            </div>
                                                            <div className='d-flex gap-1 align-items-center'>
                                                                <p className='text font-m fs-10'>Applied By :</p>
                                                                <p className='text fs-10'>{item?.AppliedBy}</p>
                                                            </div>
                                                            <div className='d-flex gap-1 align-items-center'>
                                                                <p className='text font-m fs-10'>Applied At :</p>
                                                                <p className='text fs-10'>{item?.AppliedAt}</p>
                                                            </div>
                                                            <div className='d-flex gap-10 align-items-center'>
                                                                <p className='text font-m fs-10'>Status :</p>
                                                                <p className='heading fs-10 fst-italic za-schedule'>{item?.Status}</p>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>

                            }
                        </div>
                        <i className='icon-x-cros fs-20 fs-20 dark-clr' onClick={() => onClose()} ></i>
                    </div>

                </div>
                <div className='za-master_header d-flex align-items-center gap-2 mx-10'>
                    <div className="img-container s-35 circle">
                        {PatientDetails?.ProfilePictureURL ? <img src={PatientDetails?.ProfilePictureURL} alt="" /> :
                            <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white ${isMale(PatientDetails.Gender) ? 'za-male' : isFemale(PatientDetails.Gender) ? 'za-female' : 'za-others'}`}>
                                <InitialLetters classes={""} name={PatientDetails?.Name} splitBy={' '} />
                            </p>
                        }
                    </div>
                    <div className="w-100">
                        <p className='heading fs-12'>{PatientDetails?.Name || ""} <span className='text font-m fs-11 ar-light-color'> {`${PatientDetails?.DOB || ""} ${PatientDetails?.Age ? '(' + PatientDetails?.Age + ')' : ""} ${PatientDetails?.Gender || ""}`}</span></p>
                        <div className='d-flex align-items-center justify-content-between'>
                            {PatientDetails?.PatientInsuranceID && !InsuranceEditable && <p className='heading fs-12 drk-green-clr '>{PatientDetails?.InsuranceName}<i className='icon-Icon-material-edit fs-10 ms-2' onClick={() => setInsuranceEditable(true)}></i></p>}

                            {InsuranceEditable &&
                                <div className=" d-flex align-items-center gap-2">
                                    <div className="input">
                                        <SuperSearchList
                                            type="client"
                                            id="PatientInsuranceIDAR"
                                            name="PatientInsuranceIDAR"
                                            searchValue={PatientDetails?.InsuranceName}
                                            data={InsuranceDropDown || []}
                                            getSelectedData={handleInsuranceSelected}
                                            onChange={handleInsuranceInputChange}
                                            icon="Simple"
                                            sup_btn="sup_btn"
                                            sup_inp="superSearchVisitInp"
                                            className="form-control fc-xs"
                                        />
                                    </div>
                                    <i className='icon-Icon-metro-cross fs-10 ms-1' onClick={() => setInsuranceEditable(false)}></i>
                                </div>
                            }

                            <p className='text fs-12'>Medicaid # <span className='text font-m fs-12'>{PatientDetails?.MedicaidNo || ""}</span></p>
                        </div>
                    </div>
                </div>

                <div className='d-flex gap-10 za-fields_input ps-4 pe-10'>
                    <div className='col-md-3'>
                        <label htmlFor="" className='text font-m fs-12 ar-light-color'>Authorized Services</label>
                        <div className={`input`}>
                            <SuperSearchList
                                type="client"
                                id='PatientAuthorizationID'
                                name='PatientAuthorizationID'
                                searchValue={mainModalMasterWeek?.PatientAuthorizationID}
                                // data={AuthDropDown}
                                data={[
                                    { display: '', value: '' },
                                    ...(AuthDropDown || [])
                                ]}
                                onChange={handleChangeDD}
                                getSelectedData={handleSelectedData}
                                // is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                inputError={MasterWeekValidationModal?.PatientAuthorizationID ? true : false}
                            />
                            {/* {MasterWeekValidationModal?.PatientAuthorizationID} */}
                            {/* <select className="form-control fc-xs rounded-1" id="PatientAuthorizationID" name="PatientAuthorizationID" value={mainModalMasterWeek?.PatientAuthorizationID} onChange={handleOnChangeFilters}>
                                    {AuthDropDown?.map((Auth) => {
                                        return (
                                            <option value={Auth?.value}>{Auth?.display}</option>
                                        )
                                    })}
                                </select> */}
                        </div>
                    </div>
                    <div className='col-md-2-2'>
                        <label htmlFor="" className='text font-m fs-12 ar-light-color'>Schedule Period</label>
                        <div className="input">
                            <SuperSearchList
                                type="client"
                                id='SchedulePeriod'
                                name='SchedulePeriod'
                                searchValue={mainModalMasterWeek?.SchedulePeriod}
                                // data={AuthDropDown}
                                data={[
                                    { display: '', value: '' },
                                    { display: 'One Week', value: 'One Week' }
                                ]}
                                onChange={handleChangeDD}
                                getSelectedData={handleSelectedData}
                                // is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                inputError={MasterWeekValidationModal?.PatientAuthorizationID ? true : false}
                            />
                            {/* <select className="form-control fc-xs rounded-1" id="SchedulePeriod" name="SchedulePeriod" value={mainModalMasterWeek?.SchedulePeriod} onChange={handleOnChangeFilters}>
                                <option value=""></option>
                                <option value={'One Week'}>One Week</option>
                            </select> */}
                        </div>
                    </div>

                    <div className='col-md-4 align-content-end ar-daterange input_field-disable01 pe-none'>
                        <label htmlFor="" className='text font-m fs-12 ar-light-color'>Date</label>
                        <CalendaRangeInput searchParam={mainModalMasterWeek} setSearchParam={setMainModalMasterWeek} defaultDates={dateRange} label={false} options={['Date']} />
                    </div>

                    <div className='col-md-2 d-flex align-items-end'>
                        <button className='btn btn-orange  text-white rounded' onClick={() => LoadData(saveModalMasterWeek)}>Search</button>
                    </div>

                </div>
                <div className='za-master-content-scroll hover-scrollbar ps-4 pe-10'>
                    <div>

                        <div className="mt-1 d-flex days_header ps-30">
                            <div className="col-md-2 ps-3">
                                <p >Start Time</p>
                            </div>
                            <div className="col-md-2 ps-3">
                                <p >End Time </p>
                            </div>
                            <div className="col-md-3 ps-5">
                                <p >Caregiver</p>
                            </div>
                            <div className="col-md-2 ">
                                <p >Unit(s)</p>
                            </div>
                            {/* <div className='d-flex align-items-center'>
                                {IsRecordExist && <i className='icon-Icon-material-edit fs-10 cursor-pointer' onClick={() => handleEditMode()}></i>}
                            </div> */}
                            {IsRecordExist && AuthSearched &&
                                <div className='I_cons align-items-center col-md-3 justify-content-end d-flex gap-1  pe-1-5'>
                                    <div>
                                    </div>
                                    {/* <div className="za-denied-status master-week position-relative d-flex">
                                        <i className='icon-Vector15 fs-13'></i>
                                        <p className='xsm_text text-light tool_tip'>Only New and Scheduled visits can be modified or deleted</p>
                                    </div> */}
                                    {ViewMode ? <i className='icon-Icon-material-edit fs-10 cursor-pointer' onClick={() => handleEditMode()}></i>
                                        : <i className='icon-Icon-metro-cross fs-10 ms-1' onClick={() => handleEditMode()}></i>}
                                    <i className='icon-delete text-danger fs-13' onClick={() => handleDelete()}></i>
                                </div>}
                        </div>

                        <div className={`timing pt-2 pb-2 ${ViewMode ? 'View_Mode' : ''}`}>
                            <div className="mb-2 align-items-center">
                                <div className={`time_slot pd-lf ${((!ShowAll && DaysSelected?.every((item) => item?.dayName !== 'Monday') || (isNull(mainModalMasterWeekSchedule?.Auth?.Mon) || mainModalMasterWeekSchedule?.Auth?.Mon == 0.00)) ? 'input_field-disable01' : (ShowAll && (isNull(mainModalMasterWeekSchedule?.Auth?.Mon) || mainModalMasterWeekSchedule?.Auth?.Mon == 0.00)) ? 'input_field-disable01' : '')}`}>
                                    <div className="heading day mon">
                                        <span>MON</span>
                                    </div>
                                    <div className={`col-md-2 input ar-multiple-br ${MasterScheduleValidationModal?.MonStartTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='MonStartTime'
                                            name='MonStartTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.MonStartTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        > */}
                                        {/* <option value="" className='text fs-12'>08:00 AM</option> */}
                                        {/* {TotalTimeArray?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='MonStartTime'
                                            name='MonStartTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.MonStartTime}
                                            data={TotalTimeArray}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.MonStartTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.MonStartTime} */}
                                    </div>
                                    <div className={`col-md-2 input ar-multiple-br pe-1 ${MasterScheduleValidationModal?.MonEndTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='MonEndTime'
                                            name='MonEndTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.MonEndTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            <option value=""></option>
                                            {TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.MonStartTime, item?.value);
                                            })?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='MonEndTime'
                                            name='MonEndTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.MonEndTime}
                                            data={TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.MonStartTime, item?.value);
                                            })}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.MonEndTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.MonEndTime} */}
                                    </div>
                                    <div className='col-md-1 check_box'>
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center form-check-input p-0'
                                                id="MonChecked"
                                                name="MonChecked"
                                                // value={mainModalMasterWeekSchedule?.MonChecked}
                                                checked={mainModalMasterWeekSchedule?.Auth?.MonChecked}
                                                onChange={(e) => handleOnChangeSchedule(e, true)}
                                            />
                                        </div>
                                    </div>
                                    <div className={`input col-md-2 ar-multiple-br  ${MasterScheduleValidationModal?.MonCaregiverID ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='MonCaregiverID'
                                            name='MonCaregiverID'
                                            value={mainModalMasterWeekSchedule?.Auth?.MonCaregiverID}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {CareGiverDD?.map((CG) => {
                                                return (
                                                    <>
                                                        <option className='text fs-12' value={CG?.value}>{CG?.display}</option>
                                                    </>
                                                )
                                            })} */}
                                        {/* <option value={''} className='text fs-12'>HomeCare Agency</option> */}
                                        {/* </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='MonCaregiverID'
                                            name='MonCaregiverID'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.MonCareGiver}
                                            data={CareGiverDD}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                        />
                                        {/* {MasterScheduleValidationModal?.MonCaregiverID} */}
                                    </div>
                                    <div className='col-md-5 ps-1-5'>
                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                            {console.log("object", (((scheduledUnitsADC?.Mon?.scheduled))), "_", ((scheduledUnits?.Mon?.overScheduled)), ((scheduledUnits?.Mon?.underScheduled)))}
                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Mon) || 0}
                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                    !isNull(scheduledUnitsADC?.Mon?.scheduled) && (
                                                        <>| Scheduled: {scheduledUnitsADC?.Mon?.scheduled}</>
                                                    )
                                                ) : (
                                                    <>
                                                        {/* General Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Mon?.scheduled) && (
                                                            <>| Scheduled: {scheduledUnits?.Mon?.scheduled}</>
                                                        )}

                                                        {/* Over Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Mon?.overScheduled) ? (
                                                            <>| Over Scheduled: {scheduledUnits?.Mon?.overScheduled}</>
                                                        ) : (
                                                            /* Under Scheduled Display */
                                                            !isNull(scheduledUnits?.Mon?.underScheduled) && (
                                                                <>| Under Scheduled: {scheduledUnits?.Mon?.underScheduled}</>
                                                            )
                                                        )}
                                                    </>
                                                )}
                                            </p>
                                            {/* <i className='icon-delete fs-11 text-danger'></i> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {mainModalMasterWeekSchedule?.Auth?.MonChecked && <div className={`za-day_shifts hover-scrollbar d-flex flex-column mb-2 gap-01 ${ViewMode ? 'input_field-disable01' : ''}`}>
                                {mainModalMasterWeekSchedule?.Auth?.Shifts?.filter((shift) => {
                                    return shift
                                }).map((item, index) => {
                                    return (
                                        <div className={`d-flex align-items-baseline gap-01 ${(isNull(item['Mon']) || item['Mon'] == 0.00) ? 'input_field-disable01' : ''}`}>

                                            <div className='col-md-1 check_box'>
                                                <div className="heading za_shift">
                                                    <span className='text font-m fs-9 text-white'>{`Shift ${index + 1}`}</span>
                                                </div>
                                            </div>
                                            <div className="align-items-center input_field-bg-clr col-md-11">
                                                <div className="time_slot">
                                                    <div className='col-md-4 d-flex  gap-2 me-1'>
                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.MonStartTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='MonStartTime'
                                                                name='MonStartTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.MonStartTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            >
                                                                {TotalTimeArray?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='MonStartTime'
                                                                name='MonStartTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.MonStartTime}
                                                                data={TotalTimeArray}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.MonStartTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.MonStartTime} */}
                                                        </div>


                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.MonEndTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='MonEndTime'
                                                                name='MonEndTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.MonEndTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            > */}
                                                            {/* {TotalTimeArray?.map((item) => {
                                                        return (
                                                            <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                        )
                                                    })} */}
                                                            {/* <option value=""></option>
                                                                {TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.MonStartTime, item?.value);
                                                                })?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='MonEndTime'
                                                                name='MonEndTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.MonEndTime}
                                                                data={TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.MonStartTime, item?.value);
                                                                })}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.MonEndTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.MonEndTime} */}
                                                        </div>

                                                    </div>

                                                    <div className='col-md-1 check_box ms-2'>
                                                        <div className="custom_check_box ">
                                                            <input type="checkbox"
                                                                className='align-self-center form-check-input p-0'
                                                                id="MonChecked"
                                                                name="MonChecked"
                                                                checked={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.MonChecked}
                                                                // checked={mainModalMasterWeekSchedule?.Auth?.TueChecked}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index, true)}
                                                            />
                                                        </div>
                                                    </div>



                                                    <div className={`input ar-multiple-br col-md-2 w-17 ${ScheduleShiftValidation?.[index]?.MonCaregiverID ? 'error' : ''}`}>

                                                        {/* <select className="form-control"
                                                            id='MonCaregiverID'
                                                            name='MonCaregiverID'
                                                            value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.MonCaregiverID}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                        >
                                                            {CareGiverDD?.map((CG) => {
                                                                return (
                                                                    <>
                                                                        <option className='text fs-12' value={CG?.value}>{CG?.display}</option>
                                                                    </>
                                                                )
                                                            })}
                                                        </select> */}
                                                        <SuperSearchList
                                                            type="client"
                                                            id='MonCaregiverID'
                                                            name='MonCaregiverID'
                                                            searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.MonCareGiver}
                                                            data={CareGiverDD}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                            getSelectedData={handleScheduleShiftsSelectedData}
                                                            // is={is}
                                                            index={index}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                            className="form-control rounded"
                                                        />
                                                        {/* {ScheduleShiftValidation?.[index]?.MonCaregiverID} */}
                                                    </div>
                                                    {/* <div className='col-md-6'>
                                                            <div className='d-flex align-items-center justify-content-between '>
                                                                <p className='text font-m fs-11'>{item['Mon']}</p>
                                                                {!ViewMode && <button className='btn text font-m fs-12 text-decoration-underline za-red-clr' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Mon")}>Delete</button>}
                                                            </div>

                                                        </div> */}
                                                    <div className='col-md-5 ps-1-5'>
                                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {item['Mon'] || 0.00} </p> */}
                                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(item['Mon']) || 0}
                                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                                    !isNull(scheduledShiftsUnits?.[index]?.Mon?.scheduled) && (
                                                                        <>| Scheduled: {scheduledShiftsUnits?.[index]?.Mon?.scheduled}</>
                                                                    )
                                                                ) : (
                                                                    <>
                                                                        {/* General Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Mon?.scheduled) && (
                                                                            <>| Scheduled: {scheduledShiftsUnits?.[index]?.Mon?.scheduled}</>
                                                                        )}

                                                                        {/* Over Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Mon?.overScheduled) ? (
                                                                            <>| Over Scheduled: {scheduledShiftsUnits?.[index]?.Mon?.overScheduled}</>
                                                                        ) : (
                                                                            /* Under Scheduled Display */
                                                                            !isNull(scheduledShiftsUnits?.[index]?.Mon?.underScheduled) && (
                                                                                <>| Under Scheduled: {scheduledShiftsUnits?.[index]?.Mon?.underScheduled}</>
                                                                            )
                                                                        )}
                                                                    </>
                                                                )}
                                                            </p>
                                                            {/* <i className='icon-delete fs-11 text-danger' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Mon")}></i> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                        </div>
                                    )
                                })}
                            </div>}
                            {/* <div className="mb-2 align-items-center input_field-bg-clr">
                            <div className="time_slot position-relative ">
                                <div className="heading za_shift">
                                    <span className='text font-m fs-9 text-white'>Shift 2</span>
                                </div>
                                <div className='col-md-4 d-flex  gap-2 '>
                                    <div className="col-md-6 input">
                                        <select className="form-control"
                                            id='StartTime'
                                            name='StartTime'
                                            value={mainModalMasterWeekSchedule}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {TotalTimeArray?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select>
                                    </div>


                                    <div className="col-md-6 input">
                                        <select className="form-control"
                                            id='EndTime'
                                            name='EndTime'
                                            value={mainModalMasterWeekSchedule}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {TotalTimeArray?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select>
                                    </div>

                                </div>

                                <div className='col-md-7 d-flex gap-2 ps-1'>
                                    <div className="col-md-6 input">

                                        <select className="form-control w-105"
                                            id='BreakStartTime'
                                            name='BreakStartTime'
                                            value={mainModalMasterWeekSchedule}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            <option value={''} className='text fs-12'>HomeCare Agency</option>
                                        </select>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <p className='text font-m fs-11'>20</p>
                                            <button className='btn text font-m fs-12 text-decoration-underline za-red-clr'>Delete</button>
                                        </div>

                                    </div>

                                </div>


                            </div>
                        </div> */}
                            <div className="mb-2 align-items-center">
                                <div className={`time_slot pd-lf ${((!ShowAll && DaysSelected?.every((item) => item?.dayName !== 'Tuesday') || (isNull(mainModalMasterWeekSchedule?.Auth?.Tue) || mainModalMasterWeekSchedule?.Auth?.Tue == 0.00)) ? 'input_field-disable01' : (ShowAll && (isNull(mainModalMasterWeekSchedule?.Auth?.Tue) || mainModalMasterWeekSchedule?.Auth?.Tue == 0.00)) ? 'input_field-disable01' : '')}`}>
                                    <div className="heading day tue">
                                        <span>TUE</span>
                                    </div>
                                    <div className={`col-md-2 input ar-multiple-br ${MasterScheduleValidationModal?.TueStartTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='TueStartTime'
                                            name='TueStartTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.TueStartTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {TotalTimeArray?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='TueStartTime'
                                            name='TueStartTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.TueStartTime}
                                            data={TotalTimeArray}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.TueStartTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.TueStartTime} */}
                                    </div>


                                    <div className={`col-md-2 input ar-multiple-br pe-1 ${MasterScheduleValidationModal?.TueEndTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='TueEndTime'
                                            name='TueEndTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.TueEndTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        > */}
                                        {/* {TotalTimeArray?.map((item) => {
                                            return (
                                                <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                            )
                                        })} */}
                                        {/* <option value=""></option>
                                            {TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.TueStartTime, item?.value);
                                            })?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='TueEndTime'
                                            name='TueEndTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.TueEndTime}
                                            data={TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.TueStartTime, item?.value);
                                            })}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.TueEndTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.TueEndTime} */}
                                    </div>

                                    <div className='col-md-1 check_box'>
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center form-check-input p-0'
                                                id="TueChecked"
                                                name="TueChecked"
                                                checked={mainModalMasterWeekSchedule?.Auth?.TueChecked}
                                                onChange={(e) => handleOnChangeSchedule(e, true)}
                                            />
                                        </div>
                                    </div>
                                    <div className={`input col-md-2 ar-multiple-br ${MasterScheduleValidationModal?.TueCaregiverID ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='TueCaregiverID'
                                            name='TueCaregiverID'
                                            value={mainModalMasterWeekSchedule?.Auth?.TueCaregiverID}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {CareGiverDD?.map((CG) => {
                                                return (
                                                    <>
                                                        <option value={CG?.value}>{CG?.display}</option>
                                                    </>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='TueCaregiverID'
                                            name='TueCaregiverID'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.TueCareGiver}
                                            data={CareGiverDD}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                        />
                                        {/* {MasterScheduleValidationModal?.TueCaregiverID} */}
                                    </div>

                                    <div className='col-md-5 ps-1-5'>
                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Tue) || 0} {AuthSearched && (practiceType === "Adult Day Care" ? (<>| Scheduled: {scheduledUnitsADC?.Tue?.scheduled} </>) : (<>| Scheduled: {scheduledUnits?.Tue?.scheduled} | {`${!isNull(scheduledUnits?.Tue?.overScheduled) ? 'Over Scheduled: ' + scheduledUnits?.Tue?.overScheduled : 'Under Scheduled: ' + scheduledUnits?.Tue?.underScheduled}`}</>))}</p> */}
                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Tue) || 0}
                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                    !isNull(scheduledUnitsADC?.Tue?.scheduled) && (
                                                        <>| Scheduled: {scheduledUnitsADC?.Tue?.scheduled}</>
                                                    )
                                                ) : (
                                                    <>
                                                        {/* General Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Tue?.scheduled) && (
                                                            <>| Scheduled: {scheduledUnits?.Tue?.scheduled}</>
                                                        )}

                                                        {/* Over Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Tue?.overScheduled) ? (
                                                            <>| Over Scheduled: {scheduledUnits?.Tue?.overScheduled}</>
                                                        ) : (
                                                            /* Under Scheduled Display */
                                                            !isNull(scheduledUnits?.Tue?.underScheduled) && (
                                                                <>| Under Scheduled: {scheduledUnits?.Tue?.underScheduled}</>
                                                            )
                                                        )}
                                                    </>
                                                )}
                                            </p>
                                            {/* <i className='icon-delete fs-11 text-danger'></i> */}

                                        </div>
                                    </div>

                                </div>
                            </div>
                            {mainModalMasterWeekSchedule?.Auth?.TueChecked && <div className={`za-day_shifts hover-scrollbar d-flex flex-column mb-2 gap-01  ${ViewMode ? 'input_field-disable01' : ''}`}>
                                {mainModalMasterWeekSchedule?.Auth?.Shifts?.filter((shift) => {
                                    return shift
                                }).map((item, index) => {
                                    return (
                                        <div className={`d-flex align-items-baseline gap-01 ${(isNull(item['Tue']) || item['Tue'] == 0.00) ? 'input_field-disable01' : ''}`}>

                                            <div className='col-md-1 check_box' >
                                                <div className="heading za_shift">
                                                    <span className='text font-m fs-9 text-white'>{`Shift ${index + 1}`}</span>
                                                </div>
                                            </div>

                                            <div className="align-items-center input_field-bg-clr col-md-11">
                                                <div className="time_slot">
                                                    <div className='col-md-4 d-flex  gap-2 me-1'>
                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.TueStartTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='TueStartTime'
                                                                name='TueStartTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.TueStartTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            >
                                                                {TotalTimeArray?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}

                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='TueStartTime'
                                                                name='TueStartTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.TueStartTime}
                                                                data={TotalTimeArray}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.TueStartTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.TueStartTime} */}
                                                        </div>


                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.TueEndTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='TueEndTime'
                                                                name='TueEndTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.TueEndTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            > */}

                                                            {/* {TotalTimeArray?.map((item) => {
                                                        return (
                                                            <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                        )
                                                    })} */}
                                                            {/* <option value=""></option>
                                                                {TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.TueStartTime, item?.value);
                                                                })?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='TueEndTime'
                                                                name='TueEndTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.TueEndTime}
                                                                data={TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.TueStartTime, item?.value);
                                                                })}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.TueEndTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.TueEndTime} */}
                                                        </div>

                                                    </div>

                                                    <div className='col-md-1 check_box ms-2'>
                                                        <div className="custom_check_box ">
                                                            <input type="checkbox"
                                                                className='align-self-center form-check-input p-0'
                                                                id="TueChecked"
                                                                name="TueChecked"
                                                                checked={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.TueChecked}
                                                                // checked={mainModalMasterWeekSchedule?.Auth?.TueChecked}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index, true)}
                                                            />
                                                        </div>
                                                    </div>



                                                    <div className={`col-md-2 input ar-multiple-br w-17 ${ScheduleShiftValidation?.[index]?.TueCaregiverID ? 'error' : ''}`}>

                                                        {/* <select className="form-control"
                                                            id='TueCaregiverID'
                                                            name='TueCaregiverID'
                                                            value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.TueCaregiverID}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                        >
                                                            {CareGiverDD?.map((CG) => {
                                                                return (
                                                                    <>
                                                                        <option className='text fs-12' value={CG?.value}>{CG?.display}</option>
                                                                    </>
                                                                )
                                                            })}
                                                        </select> */}
                                                        <SuperSearchList
                                                            type="client"
                                                            id='TueCaregiverID'
                                                            name='TueCaregiverID'
                                                            searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.TueCareGiver}
                                                            data={CareGiverDD}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                            getSelectedData={handleScheduleShiftsSelectedData}
                                                            // is={is}
                                                            index={index}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                            className="form-control rounded"
                                                        />
                                                        {/* {ScheduleShiftValidation?.[index]?.TueCaregiverID} */}
                                                    </div>
                                                    {/* <div className='col-md-6'>
                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                <p className='text font-m fs-11'>{item['Tue']}</p>
                                                                {!ViewMode && <button className='btn text font-m fs-12 text-decoration-underline za-red-clr' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Tue")}>Delete</button>}
                                                            </div>
                                                        </div> */}
                                                    <div className='col-md-5 ps-1-5'>
                                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {item['Tue'] || 0.00} | Scheduled: 0 | Unscheduled: 0</p> */}
                                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(item['Tue']) || 0}
                                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                                    !isNull(scheduledShiftsUnits?.[index]?.Tue?.scheduled) && (
                                                                        <> | Scheduled: {scheduledShiftsUnits?.[index]?.Tue?.scheduled}</>
                                                                    )
                                                                ) : (
                                                                    <>
                                                                        {/* General Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Tue?.scheduled) && (
                                                                            <> | Scheduled: {scheduledShiftsUnits?.[index]?.Tue?.scheduled}</>
                                                                        )}

                                                                        {/* Over Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Tue?.overScheduled) ? (
                                                                            <> | Over Scheduled: {scheduledShiftsUnits?.[index]?.Tue?.overScheduled}</>
                                                                        ) : (
                                                                            /* Under Scheduled Display */
                                                                            !isNull(scheduledShiftsUnits?.[index]?.Tue?.underScheduled) && (
                                                                                <> | Under Scheduled: {scheduledShiftsUnits?.[index]?.Tue?.underScheduled}</>
                                                                            )
                                                                        )}
                                                                    </>
                                                                )}
                                                            </p>
                                                            {/* <i className='icon-delete fs-11 text-danger' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Tue")}></i> */}
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>}
                            <div className="mb-2 align-items-center">
                                <div className={`time_slot pd-lf ${((!ShowAll && DaysSelected?.every((item) => item?.dayName !== 'Wednesday') || (isNull(mainModalMasterWeekSchedule?.Auth?.Wed) || mainModalMasterWeekSchedule?.Auth?.Wed == 0.00)) ? 'input_field-disable01' : (ShowAll && (isNull(mainModalMasterWeekSchedule?.Auth?.Wed) || mainModalMasterWeekSchedule?.Auth?.Wed == 0.00)) ? 'input_field-disable01' : '')}`}>
                                    <div className="heading day wed">
                                        <span>WED</span>
                                    </div>
                                    <div className={`col-md-2 input ar-multiple-br ${MasterScheduleValidationModal?.WedStartTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='WedStartTime'
                                            name='WedStartTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.WedStartTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {TotalTimeArray?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='WedStartTime'
                                            name='WedStartTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.WedStartTime}
                                            data={TotalTimeArray}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.WedStartTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.WedStartTime} */}
                                    </div>


                                    <div className={`col-md-2 input ar-multiple-br pe-1 ${MasterScheduleValidationModal?.WedEndTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='WedEndTime'
                                            name='WedEndTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.WedEndTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        > */}
                                        {/* {TotalTimeArray?.map((item) => {
                                            return (
                                                <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                            )
                                        })} */}
                                        {/* <option value=""></option>
                                            {TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.WedStartTime, item?.value);
                                            })?.map((item) => {
                                                return (
                                                    <React.Fragment>
                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                    </React.Fragment>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='WedEndTime'
                                            name='WedEndTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.WedEndTime}
                                            data={TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.WedStartTime, item?.value);
                                            })}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.WedEndTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.WedEndTime} */}
                                    </div>

                                    <div className='col-md-1 check_box'>
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center form-check-input p-0'
                                                id="WedChecked"
                                                name="WedChecked"
                                                checked={mainModalMasterWeekSchedule?.Auth?.WedChecked}
                                                onChange={(e) => handleOnChangeSchedule(e, true)}
                                            />
                                        </div>
                                    </div>
                                    <div className={`input col-md-2 ar-multiple-br ${MasterScheduleValidationModal?.WedCaregiverID ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='WedCaregiverID'
                                            name='WedCaregiverID'
                                            value={mainModalMasterWeekSchedule?.Auth?.WedCaregiverID}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {CareGiverDD?.map((CG) => {
                                                return (
                                                    <>
                                                        <option value={CG?.value}>{CG?.display}</option>
                                                    </>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='WedCaregiverID'
                                            name='WedCaregiverID'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.WedCareGiver}
                                            data={CareGiverDD}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                        />
                                        {/* {MasterScheduleValidationModal?.WedCaregiverID} */}
                                    </div>

                                    <div className='col-md-5 ps-1-5'>
                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Wed) || 0} {AuthSearched && (practiceType === "Adult Day Care" ? (<>| Scheduled: {scheduledUnitsADC?.Wed?.scheduled} </>) : (<>| Scheduled: {scheduledUnits?.Wed?.scheduled} | {`${!isNull(scheduledUnits?.Wed?.overScheduled) ? 'Over Scheduled: ' + scheduledUnits?.Wed?.overScheduled : 'Under Scheduled: ' + scheduledUnits?.Wed?.underScheduled}`}</>))}</p> */}
                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Wed) || 0}
                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                    !isNull(scheduledUnitsADC?.Wed?.scheduled) && (
                                                        <>| Scheduled: {scheduledUnitsADC?.Wed?.scheduled}</>
                                                    )
                                                ) : (
                                                    <>
                                                        {/* General Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Wed?.scheduled) && (
                                                            <>| Scheduled: {scheduledUnits?.Wed?.scheduled}</>
                                                        )}

                                                        {/* Over Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Wed?.overScheduled) ? (
                                                            <>| Over Scheduled: {scheduledUnits?.Wed?.overScheduled}</>
                                                        ) : (
                                                            /* Under Scheduled Display */
                                                            !isNull(scheduledUnits?.Wed?.underScheduled) && (
                                                                <>| Under Scheduled: {scheduledUnits?.Wed?.underScheduled}</>
                                                            )
                                                        )}
                                                    </>
                                                )}
                                            </p>
                                            {/* <i className='icon-delete fs-11 text-danger'></i> */}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {mainModalMasterWeekSchedule?.Auth?.WedChecked && <div className={`za-day_shifts hover-scrollbar d-flex flex-column mb-2 gap-01 ${ViewMode ? 'input_field-disable01' : ''}`}>
                                {mainModalMasterWeekSchedule?.Auth?.Shifts?.filter((shift) => {
                                    return shift
                                }).map((item, index) => {
                                    return (
                                        <div className={`d-flex align-items-baseline gap-01 ${(isNull(item['Wed']) || item['Wed'] == 0.00) ? 'input_field-disable01' : ''}`}>

                                            <div className='col-md-1 check_box ' >
                                                <div className="heading za_shift">
                                                    <span className='text font-m fs-9 text-white'>{`Shift ${index + 1}`}</span>
                                                </div>
                                            </div>
                                            <div className="align-items-center input_field-bg-clr col-md-11">
                                                <div className="time_slot  ">
                                                    <div className='col-md-4 d-flex  gap-2 me-1'>
                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.WedStartTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='WedStartTime'
                                                                name='WedStartTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.WedStartTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            >
                                                                {TotalTimeArray?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}

                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='WedStartTime'
                                                                name='WedStartTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.WedStartTime}
                                                                data={TotalTimeArray}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.WedStartTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.WedStartTime} */}
                                                        </div>


                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.WedEndTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='WedEndTime'
                                                                name='WedEndTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.WedEndTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            > */}
                                                            {/* {TotalTimeArray?.map((item) => {
                                                        return (
                                                            <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                        )
                                                    })} */}
                                                            {/* <option value=""></option>
                                                                {TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.WedStartTime, item?.value);
                                                                })?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='WedEndTime'
                                                                name='WedEndTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.WedEndTime}
                                                                data={TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.WedEndTime, item?.value);
                                                                })}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.WedEndTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.WedEndTime} */}
                                                        </div>

                                                    </div>

                                                    <div className='col-md-1 check_box ms-2'>
                                                        <div className="custom_check_box ">
                                                            <input type="checkbox"
                                                                className='align-self-center form-check-input p-0'
                                                                id="WedChecked"
                                                                name="WedChecked"
                                                                checked={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.WedChecked}
                                                                // checked={mainModalMasterWeekSchedule?.Auth?.TueChecked}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index, true)}
                                                            />
                                                        </div>
                                                    </div>



                                                    <div className={`col-md-2 input ar-multiple-br w-17 ${ScheduleShiftValidation?.[index]?.WedCaregiverID ? 'error' : ''}`}>
                                                        {/* <select className="form-control"
                                                            id='WedCaregiverID'
                                                            name='WedCaregiverID'
                                                            value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.WedCaregiverID}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                        >
                                                            {CareGiverDD?.map((CG) => {
                                                                return (
                                                                    <>
                                                                        <option value={CG?.value}>{CG?.display}</option>
                                                                    </>
                                                                )
                                                            })}
                                                        </select> */}
                                                        <SuperSearchList
                                                            type="client"
                                                            id='WedCaregiverID'
                                                            name='WedCaregiverID'
                                                            searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.WedCareGiver}
                                                            data={CareGiverDD}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                            getSelectedData={handleScheduleShiftsSelectedData}
                                                            // is={is}
                                                            index={index}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                            className="form-control rounded"
                                                        />
                                                        {/* {ScheduleShiftValidation?.[index]?.WedCaregiverID} */}
                                                    </div>
                                                    {/* <div className='col-md-6'>
                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                <p className='text font-m fs-11'>{item['Wed']}</p>
                                                                {!ViewMode && <button className='btn text font-m fs-12 text-decoration-underline za-red-clr' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Wed")}>Delete</button>}
                                                            </div>

                                                        </div> */}

                                                    <div className='col-md-5 ps-1-5'>
                                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {item['Wed'] || 0.00} | Scheduled: 0 | Unscheduled: 0</p> */}
                                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(item['Wed']) || 0}
                                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                                    !isNull(scheduledShiftsUnits?.[index]?.Wed?.scheduled) && (
                                                                        <> | Scheduled: {scheduledShiftsUnits?.[index]?.Wed?.scheduled}</>
                                                                    )
                                                                ) : (
                                                                    <>
                                                                        {/* General Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Wed?.scheduled) && (
                                                                            <> | Scheduled: {scheduledShiftsUnits?.[index]?.Wed?.scheduled}</>
                                                                        )}

                                                                        {/* Over Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Wed?.overScheduled) ? (
                                                                            <> | Over Scheduled: {scheduledShiftsUnits?.[index]?.Wed?.overScheduled}</>
                                                                        ) : (
                                                                            /* Under Scheduled Display */
                                                                            !isNull(scheduledShiftsUnits?.[index]?.Wed?.underScheduled) && (
                                                                                <> | Under Scheduled: {scheduledShiftsUnits?.[index]?.Wed?.underScheduled}</>
                                                                            )
                                                                        )}
                                                                    </>
                                                                )}
                                                            </p>
                                                            {/* <i className='icon-delete fs-11 text-danger' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Wed")}></i> */}
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>}
                            <div className="mb-2 align-items-center">
                                {/* {console.log("CONDITIONS", (!ShowAll && DaysSelected?.every((item) => item?.dayName !== 'Thursday') && (isNull(mainModalMasterWeekSchedule?.Auth?.Thu) || mainModalMasterWeekSchedule?.Auth?.Thu == 0.00)), !ShowAll, DaysSelected?.every((item) => item?.dayName !== 'Thursday'), (isNull(mainModalMasterWeekSchedule?.Auth?.Thu) || mainModalMasterWeekSchedule?.Auth?.Thu == 0.00))} */}
                                <div className={`time_slot pd-lf ${((!ShowAll && DaysSelected?.every((item) => item?.dayName !== 'Thursday') || (isNull(mainModalMasterWeekSchedule?.Auth?.Thu) || mainModalMasterWeekSchedule?.Auth?.Thu == 0.00)) ? 'input_field-disable01' : (ShowAll && (isNull(mainModalMasterWeekSchedule?.Auth?.Thu) || mainModalMasterWeekSchedule?.Auth?.Thu == 0.00)) ? 'input_field-disable01' : '')}`}>
                                    <div className="heading day thu">
                                        <span>THU</span>
                                    </div>
                                    <div className={`col-md-2 input ar-multiple-br ${MasterScheduleValidationModal?.ThuStartTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='ThuStartTime'
                                            name='ThuStartTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.ThuStartTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {TotalTimeArray?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='ThuStartTime'
                                            name='ThuStartTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.ThuStartTime}
                                            data={TotalTimeArray}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.ThuStartTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.ThuStartTime} */}
                                    </div>


                                    <div className={`col-md-2 input ar-multiple-br pe-1 ${MasterScheduleValidationModal?.ThuEndTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='ThuEndTime'
                                            name='ThuEndTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.ThuEndTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        > */}
                                        {/* {TotalTimeArray?.map((item) => {
                                            return (
                                                <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                            )
                                        })} */}
                                        {/* <option value=""></option>
                                            {TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.ThuStartTime, item?.value);
                                            })?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='ThuEndTime'
                                            name='ThuEndTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.ThuEndTime}
                                            data={TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.ThuStartTime, item?.value);
                                            })}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.ThuEndTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.ThuEndTime} */}
                                    </div>

                                    <div className='col-md-1 check_box'>
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center form-check-input p-0'
                                                id="ThuChecked"
                                                name="ThuChecked"
                                                checked={mainModalMasterWeekSchedule?.Auth?.ThuChecked}
                                                onChange={(e) => handleOnChangeSchedule(e, true)}
                                            />
                                        </div>
                                    </div>
                                    <div className={`input ar-multiple-br col-md-2 ${MasterScheduleValidationModal?.ThuCaregiverID ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='ThuCaregiverID'
                                            name='ThuCaregiverID'
                                            value={mainModalMasterWeekSchedule?.Auth?.ThuCaregiverID}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {CareGiverDD?.map((CG) => {
                                                return (
                                                    <>
                                                        <option value={CG?.value}>{CG?.display}</option>
                                                    </>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='ThuCaregiverID'
                                            name='ThuCaregiverID'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.ThuCareGiver}
                                            data={CareGiverDD}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                        />
                                        {/* {MasterScheduleValidationModal?.ThuCaregiverID} */}
                                    </div>

                                    {/* <div className='col-md-3 ms-3'>
                                        <div className='d-flex'>
                                            <p className='text font-m fs-11'>{mainModalMasterWeekSchedule?.Auth?.Thu}</p>
                                        </div>

                                    </div> */}
                                    <div className='col-md-5 ps-1-5'>
                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Thu) || 0} {AuthSearched && (practiceType === "Adult Day Care" ? (<>| Scheduled: {scheduledUnitsADC?.Thu?.scheduled} </>) : (<>| Scheduled: {scheduledUnits?.Thu?.scheduled} | {`${!isNull(scheduledUnits?.Thu?.overScheduled) ? 'Over Scheduled: ' + scheduledUnits?.Thu?.overScheduled : 'Under Scheduled: ' + scheduledUnits?.Thu?.underScheduled}`}</>))}</p> */}
                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Thu) || 0}
                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                    !isNull(scheduledUnitsADC?.Thu?.scheduled) && (
                                                        <>| Scheduled: {scheduledUnitsADC?.Thu?.scheduled}</>
                                                    )
                                                ) : (
                                                    <>
                                                        {/* General Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Thu?.scheduled) && (
                                                            <>| Scheduled: {scheduledUnits?.Thu?.scheduled}</>
                                                        )}

                                                        {/* Over Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Thu?.overScheduled) ? (
                                                            <>| Over Scheduled: {scheduledUnits?.Thu?.overScheduled}</>
                                                        ) : (
                                                            /* Under Scheduled Display */
                                                            !isNull(scheduledUnits?.Thu?.underScheduled) && (
                                                                <>| Under Scheduled: {scheduledUnits?.Thu?.underScheduled}</>
                                                            )
                                                        )}
                                                    </>
                                                )}
                                            </p>
                                            {/* <i className='icon-delete fs-11 text-danger'></i> */}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {mainModalMasterWeekSchedule?.Auth?.ThuChecked && <div className={`za-day_shifts hover-scrollbar d-flex flex-column mb-2 gap-01 ${ViewMode ? 'input_field-disable01' : ''}`}>
                                {mainModalMasterWeekSchedule?.Auth?.Shifts?.filter((shift) => {
                                    return shift
                                }).map((item, index) => {
                                    return (
                                        <div className={`d-flex align-items-baseline gap-01  ${(isNull(item['Thu']) || item['Thu'] == 0.00) ? 'input_field-disable01' : ''}`}>

                                            <div className='col-md-1 check_box ' >
                                                <div className="heading za_shift">
                                                    <span className='text font-m fs-9 text-white'>{`Shift ${index + 1}`}</span>
                                                </div>
                                            </div>
                                            <div className="align-items-center input_field-bg-clr col-md-11">
                                                <div className="time_slot ">
                                                    <div className='col-md-4 d-flex  gap-2 me-1'>
                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.ThuStartTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='ThuStartTime'
                                                                name='ThuStartTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ThuStartTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            >
                                                                {TotalTimeArray?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='ThuStartTime'
                                                                name='ThuStartTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ThuStartTime}
                                                                data={TotalTimeArray}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.ThuStartTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.ThuStartTime} */}
                                                        </div>


                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.ThuEndTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='ThuEndTime'
                                                                name='ThuEndTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ThuEndTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            > */}
                                                            {/* {TotalTimeArray?.map((item) => {
                                                        return (
                                                            <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                        )
                                                    })} */}
                                                            {/* <option value=""></option>
                                                                {TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ThuStartTime, item?.value);
                                                                })?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='ThuEndTime'
                                                                name='ThuEndTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ThuEndTime}
                                                                data={TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ThuStartTime, item?.value);
                                                                })}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.ThuEndTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.ThuEndTime} */}
                                                        </div>

                                                    </div>

                                                    <div className='col-md-1 check_box ms-2'>
                                                        <div className="custom_check_box ">
                                                            <input type="checkbox"
                                                                className='align-self-center form-check-input p-0'
                                                                id="ThuChecked"
                                                                name="ThuChecked"
                                                                checked={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ThuChecked}
                                                                // checked={mainModalMasterWeekSchedule?.Auth?.TueChecked}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index, true)}
                                                            />
                                                        </div>
                                                    </div>



                                                    <div className={`col-md-2 input ar-multiple-br w-17 ${ScheduleShiftValidation?.[index]?.ThuCaregiverID ? 'error' : ''}`}>

                                                        {/* <select className="form-control "
                                                            id='ThuCaregiverID'
                                                            name='ThuCaregiverID'
                                                            value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ThuCaregiverID}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                        >
                                                            {CareGiverDD?.map((CG) => {
                                                                return (
                                                                    <>
                                                                        <option value={CG?.value}>{CG?.display}</option>
                                                                    </>
                                                                )
                                                            })}
                                                        </select> */}
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ThuCaregiverID'
                                                            name='ThuCaregiverID'
                                                            searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ThuCareGiver}
                                                            data={CareGiverDD}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                            getSelectedData={handleScheduleShiftsSelectedData}
                                                            // is={is}
                                                            index={index}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                            className="form-control rounded"
                                                        />
                                                        {/* {ScheduleShiftValidation?.[index]?.ThuCaregiverID} */}
                                                    </div>
                                                    {/* <div className='col-md-6'>
                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                <p className='text font-m fs-11'>{item['Thu']}</p>
                                                                {!ViewMode && <button className='btn text font-m fs-12 text-decoration-underline za-red-clr' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Thu")}>Delete</button>}
                                                            </div>
                                                        </div> */}

                                                    <div className='col-md-5  ps-1-5'>
                                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {item['Thu'] || 0.00} | Scheduled: 0 | Unscheduled: 0</p> */}
                                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(item['Thu']) || 0}
                                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                                    !isNull(scheduledShiftsUnits?.[index]?.Thu?.scheduled) && (
                                                                        <> | Scheduled: {scheduledShiftsUnits?.[index]?.Thu?.scheduled}</>
                                                                    )
                                                                ) : (
                                                                    <>
                                                                        {/* General Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Thu?.scheduled) && (
                                                                            <> | Scheduled: {scheduledShiftsUnits?.[index]?.Thu?.scheduled}</>
                                                                        )}

                                                                        {/* Over Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Thu?.overScheduled) ? (
                                                                            <> | Over Scheduled: {scheduledShiftsUnits?.[index]?.Thu?.overScheduled}</>
                                                                        ) : (
                                                                            /* Under Scheduled Display */
                                                                            !isNull(scheduledShiftsUnits?.[index]?.Thu?.underScheduled) && (
                                                                                <> | Under Scheduled: {scheduledShiftsUnits?.[index]?.Thu?.underScheduled}</>
                                                                            )
                                                                        )}
                                                                    </>
                                                                )}
                                                            </p>
                                                            {/* <i className='icon-delete fs-11 text-danger' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Thu")}></i> */}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    )
                                })}
                            </div>}
                            <div className="mb-2 align-items-center">
                                <div className={`time_slot pd-lf ${((!ShowAll && DaysSelected?.every((item) => item?.dayName !== 'Friday') || (isNull(mainModalMasterWeekSchedule?.Auth?.Fri) || mainModalMasterWeekSchedule?.Auth?.Fri == 0.00)) ? 'input_field-disable01' : (ShowAll && (isNull(mainModalMasterWeekSchedule?.Auth?.Fri) || mainModalMasterWeekSchedule?.Auth?.Fri == 0.00)) ? 'input_field-disable01' : '')}`}>
                                    <div className="heading day fri">
                                        <span>FRI</span>
                                    </div>
                                    <div className={`col-md-2 input ar-multiple-br ${MasterScheduleValidationModal?.FriStartTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='FriStartTime'
                                            name='FriStartTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.FriStartTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {TotalTimeArray?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='FriStartTime'
                                            name='FriStartTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.FriStartTime}
                                            data={TotalTimeArray}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.FriStartTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.FriStartTime} */}
                                    </div>


                                    <div className={`col-md-2 input ar-multiple-br pe-1 ${MasterScheduleValidationModal?.FriEndTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='FriEndTime'
                                            name='FriEndTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.FriEndTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        > */}
                                        {/* {TotalTimeArray?.map((item) => {
                                            return (
                                                <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                            )
                                        })} */}
                                        {/* <option value=""></option>
                                            {TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.FriStartTime, item?.value);
                                            })?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='FriEndTime'
                                            name='FriEndTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.FriEndTime}
                                            data={TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.FriStartTime, item?.value);
                                            })}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.FriEndTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.FriEndTime} */}
                                    </div>

                                    <div className='col-md-1 check_box'>
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center form-check-input p-0'
                                                id="FriChecked"
                                                name="FriChecked"
                                                checked={mainModalMasterWeekSchedule?.Auth?.FriChecked}
                                                onChange={(e) => handleOnChangeSchedule(e, true)}
                                            />
                                        </div>
                                    </div>
                                    <div className={`input col-md-2 ar-multiple-br ${MasterScheduleValidationModal?.FriCaregiverID ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='FriCaregiverID'
                                            name='FriCaregiverID'
                                            value={mainModalMasterWeekSchedule?.Auth?.FriCaregiverID}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {CareGiverDD?.map((CG) => {
                                                return (
                                                    <>
                                                        <option className='text fs-12' value={CG?.value}>{CG?.display}</option>
                                                    </>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='FriCaregiverID'
                                            name='FriCaregiverID'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.FriCareGiver}
                                            data={CareGiverDD}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                        />
                                        {/* {MasterScheduleValidationModal?.FriCaregiverID} */}
                                    </div>

                                    <div className='col-md-5 ps-1-5'>
                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Fri) || 0}  {AuthSearched && (practiceType === "Adult Day Care" ? (<>| Scheduled: {scheduledUnitsADC?.Fri?.scheduled} </>) : (<>| Scheduled: {scheduledUnits?.Fri?.scheduled} | {`${!isNull(scheduledUnits?.Fri?.overScheduled) ? 'Over Scheduled: ' + scheduledUnits?.Fri?.overScheduled : 'Under Scheduled: ' + scheduledUnits?.Fri?.underScheduled}`}</>))}</p> */}
                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Fri) || 0}
                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                    !isNull(scheduledUnitsADC?.Fri?.scheduled) && (
                                                        <>| Scheduled: {scheduledUnitsADC?.Fri?.scheduled}</>
                                                    )
                                                ) : (
                                                    <>
                                                        {/* General Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Fri?.scheduled) && (
                                                            <>| Scheduled: {scheduledUnits?.Fri?.scheduled}</>
                                                        )}

                                                        {/* Over Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Fri?.overScheduled) ? (
                                                            <>| Over Scheduled: {scheduledUnits?.Fri?.overScheduled}</>
                                                        ) : (
                                                            /* Under Scheduled Display */
                                                            !isNull(scheduledUnits?.Fri?.underScheduled) && (
                                                                <>| Under Scheduled: {scheduledUnits?.Fri?.underScheduled}</>
                                                            )
                                                        )}
                                                    </>
                                                )}
                                            </p>
                                            {/* <i className='icon-delete fs-11 text-danger'></i> */}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {mainModalMasterWeekSchedule?.Auth?.FriChecked && <div className={`za-day_shifts hover-scrollbar d-flex flex-column mb-2 gap-01  ${ViewMode ? 'input_field-disable01' : ''}`}>
                                {mainModalMasterWeekSchedule?.Auth?.Shifts?.filter((shift) => {
                                    return shift
                                }).map((item, index) => {
                                    return (
                                        <div className={`d-flex align-items-baseline gap-01 ${(isNull(item['Fri']) || item['Fri'] == 0.00) ? 'input_field-disable01' : ''}`}>

                                            <div className='col-md-1 check_box ' >
                                                <div className="heading za_shift">
                                                    <span className='text font-m fs-9 text-white'>{`Shift ${index + 1}`}</span>
                                                </div>
                                            </div>
                                            <div className="align-items-center input_field-bg-clr col-md-11">
                                                <div className="time_slot">
                                                    <div className='col-md-4 d-flex  gap-2 me-1'>
                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.FriStartTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='FriStartTime'
                                                                name='FriStartTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.FriStartTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            >
                                                                {TotalTimeArray?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='FriStartTime'
                                                                name='FriStartTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.FriStartTime}
                                                                data={TotalTimeArray}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.FriStartTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.FriStartTime} */}
                                                        </div>


                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.FriEndTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='FriEndTime'
                                                                name='FriEndTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.FriEndTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            > */}
                                                            {/* {TotalTimeArray?.map((item) => {
                                                        return (
                                                            <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                        )
                                                    })} */}
                                                            {/* <option value=""></option>
                                                                {TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.FriStartTime, item?.value);
                                                                })?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='FriEndTime'
                                                                name='FriEndTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.FriEndTime}
                                                                data={TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.FriStartTime, item?.value);
                                                                })}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.FriEndTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.FriEndTime} */}
                                                        </div>

                                                    </div>

                                                    <div className='col-md-1 check_box ms-2'>
                                                        <div className="custom_check_box ">
                                                            <input type="checkbox"
                                                                className='align-self-center form-check-input p-0'
                                                                id="FriChecked"
                                                                name="FriChecked"
                                                                checked={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.FriChecked}
                                                                // checked={mainModalMasterWeekSchedule?.Auth?.TueChecked}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index, true)}
                                                            />
                                                        </div>
                                                    </div>



                                                    <div className={`col-md-2 input  ar-multiple-br w-17 ${ScheduleShiftValidation?.[index]?.FriCaregiverID ? 'error' : ''}`}>

                                                        {/* <select className="form-control"
                                                            id='FriCaregiverID'
                                                            name='FriCaregiverID'
                                                            value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.FriCaregiverID}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                        >
                                                            {CareGiverDD?.map((CG) => {
                                                                return (
                                                                    <>
                                                                        <option className='text fs-12' value={CG?.value}>{CG?.display}</option>
                                                                    </>
                                                                )
                                                            })}
                                                        </select> */}
                                                        <SuperSearchList
                                                            type="client"
                                                            id='FriCaregiverID'
                                                            name='FriCaregiverID'
                                                            searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.FriCareGiver}
                                                            data={CareGiverDD}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                            getSelectedData={handleScheduleShiftsSelectedData}
                                                            // is={is}
                                                            index={index}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                            className="form-control rounded"
                                                        />
                                                        {/* {ScheduleShiftValidation?.[index]?.FriCaregiverID} */}
                                                    </div>
                                                    {/* <div className='col-md-6'>
                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                <p className='text font-m fs-11'>{item['Fri']}</p>
                                                                {!ViewMode && <button className='btn text font-m fs-12 text-decoration-underline za-red-clr' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Fri")}>Delete</button>}
                                                            </div>

                                                        </div> */}
                                                    <div className='col-md-5 ps-1-5'>
                                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {item['Fri'] || 0.00} | Scheduled: 0 | Unscheduled: 0</p> */}
                                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(item['Fri']) || 0}
                                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                                    !isNull(scheduledShiftsUnits?.[index]?.Fri?.scheduled) && (
                                                                        <> | Scheduled: {scheduledShiftsUnits?.[index]?.Fri?.scheduled}</>
                                                                    )
                                                                ) : (
                                                                    <>
                                                                        {/* General Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Fri?.scheduled) && (
                                                                            <> | Scheduled: {scheduledShiftsUnits?.[index]?.Fri?.scheduled}</>
                                                                        )}

                                                                        {/* Over Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Fri?.overScheduled) ? (
                                                                            <> | Over Scheduled: {scheduledShiftsUnits?.[index]?.Fri?.overScheduled}</>
                                                                        ) : (
                                                                            /* Under Scheduled Display */
                                                                            !isNull(scheduledShiftsUnits?.[index]?.Fri?.underScheduled) && (
                                                                                <> | Under Scheduled: {scheduledShiftsUnits?.[index]?.Fri?.underScheduled}</>
                                                                            )
                                                                        )}
                                                                    </>
                                                                )}
                                                            </p>
                                                            {/* <i className='icon-delete fs-11 text-danger' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Fri")}></i> */}
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>

                                        </div>
                                    )
                                })}
                            </div>}
                            <div className="mb-2 align-items-center">
                                <div className={`time_slot pd-lf ${((!ShowAll && DaysSelected?.every((item) => item?.dayName !== 'Saturday') || (isNull(mainModalMasterWeekSchedule?.Auth?.Sat) || mainModalMasterWeekSchedule?.Auth?.Sat == 0.00)) ? 'input_field-disable01' : (ShowAll && (isNull(mainModalMasterWeekSchedule?.Auth?.Sat) || mainModalMasterWeekSchedule?.Auth?.Sat == 0.00)) ? 'input_field-disable01' : '')}`}>
                                    <div className="heading day sat">
                                        <span>SAT</span>
                                    </div>
                                    <div className={`col-md-2 input ar-multiple-br ${MasterScheduleValidationModal?.SatStartTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='SatStartTime'
                                            name='SatStartTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.SatStartTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {TotalTimeArray?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='SatStartTime'
                                            name='SatStartTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.SatStartTime}
                                            data={TotalTimeArray}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.SatStartTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.SatStartTime} */}
                                    </div>


                                    <div className={`col-md-2 input ar-multiple-br  pe-1 ${MasterScheduleValidationModal?.SatEndTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='SatEndTime'
                                            name='SatEndTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.SatEndTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        > */}
                                        {/* {TotalTimeArray?.map((item) => {
                                            return (
                                                <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                            )
                                        })} */}
                                        {/* <option value=""></option>
                                            {TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.SatStartTime, item?.value);
                                            })?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='SatEndTime'
                                            name='SatEndTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.SatEndTime}
                                            data={TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.SatStartTime, item?.value);
                                            })}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.SatEndTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.SatEndTime} */}
                                    </div>

                                    <div className='col-md-1 check_box'>
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center form-check-input p-0'
                                                id="SatChecked"
                                                name="SatChecked"
                                                checked={mainModalMasterWeekSchedule?.Auth?.SatChecked}
                                                onChange={(e) => handleOnChangeSchedule(e, true)}
                                            />
                                        </div>
                                    </div>
                                    <div className={`input ar-multiple-br col-md-2 ${MasterScheduleValidationModal?.SatCaregiverID ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='SatCaregiverID'
                                            name='SatCaregiverID'
                                            value={mainModalMasterWeekSchedule?.Auth?.SatCaregiverID}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {CareGiverDD?.map((CG) => {
                                                return (
                                                    <>

                                                        <option className='text fs-12' value={CG?.value}>{CG?.display}</option>
                                                    </>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='SatCaregiverID'
                                            name='SatCaregiverID'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.SatCareGiver}
                                            data={CareGiverDD}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                        />
                                        {/* {MasterScheduleValidationModal?.SatCaregiverID} */}
                                    </div>


                                    <div className='col-md-5 ps-1-5'>
                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Sat) || 0} {AuthSearched && (practiceType === "Adult Day Care" ? (<>| Scheduled: {scheduledUnitsADC?.Sat?.scheduled} </>) : (<>| Scheduled: {scheduledUnits?.Sat?.scheduled} | {`${!isNull(scheduledUnits?.Sat?.overScheduled) ? 'Over Scheduled: ' + scheduledUnits?.Sat?.overScheduled : 'Under Scheduled: ' + scheduledUnits?.Sat?.underScheduled}`}</>))}</p> */}
                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Sat) || 0}
                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                    !isNull(scheduledUnitsADC?.Sat?.scheduled) && (
                                                        <>| Scheduled: {scheduledUnitsADC?.Sat?.scheduled}</>
                                                    )
                                                ) : (
                                                    <>
                                                        {/* General Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Sat?.scheduled) && (
                                                            <>| Scheduled: {scheduledUnits?.Sat?.scheduled}</>
                                                        )}

                                                        {/* Over Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Sat?.overScheduled) ? (
                                                            <>| Over Scheduled: {scheduledUnits?.Sat?.overScheduled}</>
                                                        ) : (
                                                            /* Under Scheduled Display */
                                                            !isNull(scheduledUnits?.Sat?.underScheduled) && (
                                                                <>| Under Scheduled: {scheduledUnits?.Sat?.underScheduled}</>
                                                            )
                                                        )}
                                                    </>
                                                )}
                                            </p>
                                            {/* <i className='icon-delete fs-11 text-danger'></i> */}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {mainModalMasterWeekSchedule?.Auth?.SatChecked && <div className={`za-day_shifts hover-scrollbar d-flex flex-column mb-2 gap-01  ${ViewMode ? 'input_field-disable01' : ''}`}>
                                {mainModalMasterWeekSchedule?.Auth?.Shifts?.filter((shift) => {
                                    return shift
                                }).map((item, index) => {
                                    return (
                                        <div className={`d-flex align-items-baseline gap-01 ${(isNull(item['Sat']) || item['Sat'] == 0.00) ? 'input_field-disable01' : ''}`}>

                                            <div className='col-md-1 check_box ' >
                                                <div className="heading za_shift">
                                                    <span className='text font-m fs-9 text-white'>{`Shift ${index + 1}`}</span>
                                                </div>
                                            </div>
                                            <div className="align-items-center input_field-bg-clr col-md-11">
                                                <div className="time_slot  ">
                                                    <div className='col-md-4 d-flex  gap-2 me-1'>
                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.SatStartTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='SatStartTime'
                                                                name='SatStartTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SatStartTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            >
                                                                {TotalTimeArray?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='SatStartTime'
                                                                name='SatStartTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SatStartTime}
                                                                data={TotalTimeArray}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.SatStartTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.SatStartTime} */}
                                                        </div>


                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.SatEndTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='SatEndTime'
                                                                name='SatEndTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SatEndTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            > */}
                                                            {/* {TotalTimeArray?.map((item) => {
                                                        return (
                                                            <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                        )
                                                    })} */}
                                                            {/* <option value=""></option>
                                                                {TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SatStartTime, item?.value);
                                                                })?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='SatEndTime'
                                                                name='SatEndTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SatEndTime}
                                                                data={TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SatStartTime, item?.value);
                                                                })}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.SatEndTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.SatEndTime} */}
                                                        </div>

                                                    </div>

                                                    <div className='col-md-1 check_box ms-2'>
                                                        <div className="custom_check_box ">
                                                            <input type="checkbox"
                                                                className='align-self-center form-check-input p-0'
                                                                id="SatChecked"
                                                                name="SatChecked"
                                                                checked={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SatChecked}
                                                                // checked={mainModalMasterWeekSchedule?.Auth?.TueChecked}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index, true)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className={`col-md-2 input ar-multiple-br w-17 ${ScheduleShiftValidation?.[index]?.SatCaregiverID ? 'error' : ''}`}>

                                                        {/* <select className="form-control"
                                                            id='SatCaregiverID'
                                                            name='SatCaregiverID'
                                                            value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SatCaregiverID}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                        >
                                                            {CareGiverDD?.map((CG) => {
                                                                return (
                                                                    <>
                                                                        <option className='text fs-12' value={CG?.value}>{CG?.display}</option>
                                                                    </>
                                                                )
                                                            })}
                                                        </select> */}
                                                        <SuperSearchList
                                                            type="client"
                                                            id='SatCaregiverID'
                                                            name='SatCaregiverID'
                                                            searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SatCareGiver}
                                                            data={CareGiverDD}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                            getSelectedData={handleScheduleShiftsSelectedData}
                                                            // is={is}
                                                            index={index}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                            className="form-control rounded"
                                                        />
                                                        {/* {ScheduleShiftValidation?.[index]?.SatCaregiverID} */}
                                                    </div>
                                                    {/* <div className='col-md-6'>
                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                <p className='text font-m fs-11'>{item['Sat']}</p>
                                                                {!ViewMode && <button className='btn text font-m fs-12 text-decoration-underline za-red-clr' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Sat")}>Delete</button>}
                                                            </div>

                                                        </div> */}
                                                    <div className='col-md-5  ps-1-5'>
                                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {item['Sat'] || 0.00} | Scheduled: 0 | Unscheduled: 0</p> */}
                                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(item['Sat']) || 0}
                                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                                    !isNull(scheduledShiftsUnits?.[index]?.Sat?.scheduled) && (
                                                                        <> | Scheduled: {scheduledShiftsUnits?.[index]?.Sat?.scheduled}</>
                                                                    )
                                                                ) : (
                                                                    <>
                                                                        {/* General Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Sat?.scheduled) && (
                                                                            <> | Scheduled: {scheduledShiftsUnits?.[index]?.Sat?.scheduled}</>
                                                                        )}

                                                                        {/* Over Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Sat?.overScheduled) ? (
                                                                            <> | Over Scheduled: {scheduledShiftsUnits?.[index]?.Sat?.overScheduled}</>
                                                                        ) : (
                                                                            /* Under Scheduled Display */
                                                                            !isNull(scheduledShiftsUnits?.[index]?.Sat?.underScheduled) && (
                                                                                <> | Under Scheduled: {scheduledShiftsUnits?.[index]?.Sat?.underScheduled}</>
                                                                            )
                                                                        )}
                                                                    </>
                                                                )}
                                                            </p>
                                                            {/* <i className='icon-delete fs-11 text-danger' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Sat")}></i> */}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>


                                        </div>
                                    )
                                })}
                            </div>}
                            <div className="mb-2 align-items-center">
                                <div className={`time_slot pd-lf ${((!ShowAll && DaysSelected?.every((item) => item?.dayName !== 'Sunday') || (isNull(mainModalMasterWeekSchedule?.Auth?.Sun) || mainModalMasterWeekSchedule?.Auth?.Sun == 0.00)) ? 'input_field-disable01' : (ShowAll && (isNull(mainModalMasterWeekSchedule?.Auth?.Sun) || mainModalMasterWeekSchedule?.Auth?.Sun == 0.00)) ? 'input_field-disable01' : '')}`}>
                                    <div className="heading day sun">
                                        <span>SUN</span>
                                    </div>
                                    <div className={`col-md-2 input ar-multiple-br ${MasterScheduleValidationModal?.SunStartTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='SunStartTime'
                                            name='SunStartTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.SunStartTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {TotalTimeArray?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='SunStartTime'
                                            name='SunStartTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.SunStartTime}
                                            data={TotalTimeArray}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.SunStartTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.SunStartTime} */}
                                    </div>

                                    <div className={`col-md-2 input ar-multiple-br pe-1 ${MasterScheduleValidationModal?.SunEndTime ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='SunEndTime'
                                            name='SunEndTime'
                                            value={mainModalMasterWeekSchedule?.Auth?.SunEndTime}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        > */}
                                        {/* {TotalTimeArray?.map((item) => {
                                            return (
                                                <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                            )
                                        })} */}
                                        {/* <option value=""></option>
                                            {TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.SunStartTime, item?.value);
                                            })?.map((item) => {
                                                return (
                                                    <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='SunEndTime'
                                            name='SunEndTime'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.SunEndTime}
                                            data={TotalTimeArray.filter((item) => {
                                                return compareTimes(mainModalMasterWeekSchedule?.Auth?.SunStartTime, item?.value);
                                            })}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                            inputError={MasterScheduleValidationModal?.SunEndTime ? true : false}
                                        />
                                        {/* {MasterScheduleValidationModal?.SunEndTime} */}
                                    </div>

                                    <div className='col-md-1 check_box'>
                                        <div className="custom_check_box ">
                                            <input type="checkbox"
                                                className='align-self-center form-check-input p-0'
                                                id="SunChecked"
                                                name="SunChecked"
                                                checked={mainModalMasterWeekSchedule?.Auth?.SunChecked}
                                                onChange={(e) => handleOnChangeSchedule(e, true)}
                                            />
                                        </div>
                                    </div>
                                    <div className={`input col-md-2 ar-multiple-br ${MasterScheduleValidationModal?.SunCaregiverID ? "error" : ""}`}>
                                        {/* <select className="form-control"
                                            id='SunCaregiverID'
                                            name='SunCaregiverID'
                                            value={mainModalMasterWeekSchedule?.Auth?.SunCaregiverID}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                        >
                                            {CareGiverDD?.map((CG) => {
                                                return (
                                                    <>
                                                        <option value={CG?.value}>{CG?.display}</option>
                                                    </>
                                                )
                                            })}
                                        </select> */}
                                        <SuperSearchList
                                            type="client"
                                            id='SunCaregiverID'
                                            name='SunCaregiverID'
                                            searchValue={mainModalMasterWeekSchedule?.Auth?.SunCareGiver}
                                            data={CareGiverDD}
                                            onChange={(e) => handleOnChangeSchedule(e)}
                                            getSelectedData={handleScheduleSelectedData}
                                            // is={is}
                                            // index={index}
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            className="form-control rounded"
                                        />
                                        {/* {MasterScheduleValidationModal?.SunCaregiverID} */}
                                    </div>


                                    <div className='col-md-5 ps-1-5'>
                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Sun) || 0} {AuthSearched && (practiceType === "Adult Day Care" ? (<>| Scheduled: {scheduledUnitsADC?.Sun?.scheduled} </>) : (<>| Scheduled: {scheduledUnits?.Sun?.scheduled} | {`${!isNull(scheduledUnits?.Sun?.overScheduled) ? 'Over Scheduled: ' + scheduledUnits?.Sun?.overScheduled : 'Under Scheduled: ' + scheduledUnits?.Sun?.underScheduled}`}</>))}</p> */}
                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(mainModalMasterWeekSchedule?.Auth?.Sun) || 0}
                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                    !isNull(scheduledUnitsADC?.Sun?.scheduled) && (
                                                        <>| Scheduled: {scheduledUnitsADC?.Sun?.scheduled}</>
                                                    )
                                                ) : (
                                                    <>
                                                        {/* General Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Sun?.scheduled) && (
                                                            <>| Scheduled: {scheduledUnits?.Sun?.scheduled}</>
                                                        )}

                                                        {/* Over Scheduled Display */}
                                                        {!isNull(scheduledUnits?.Sun?.overScheduled) ? (
                                                            <>| Over Scheduled: {scheduledUnits?.Sun?.overScheduled}</>
                                                        ) : (
                                                            /* Under Scheduled Display */
                                                            !isNull(scheduledUnits?.Sun?.underScheduled) && (
                                                                <>| Under Scheduled: {scheduledUnits?.Sun?.underScheduled}</>
                                                            )
                                                        )}
                                                    </>
                                                )}
                                            </p>
                                            {/* <i className='icon-delete fs-11 text-danger'></i> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {mainModalMasterWeekSchedule?.Auth?.SunChecked && <div className={`za-day_shifts hover-scrollbar d-flex flex-column mb-2 gap-01 ${ViewMode ? 'input_field-disable01' : ''}`}>
                                {mainModalMasterWeekSchedule?.Auth?.Shifts?.filter((shift) => {
                                    return shift
                                }).map((item, index) => {
                                    return (
                                        <div className={`d-flex align-items-baseline gap-01 ${(isNull(item['Sun']) || item['Sun'] == 0.00) ? 'input_field-disable01' : ''}`}>

                                            <div className='col-md-1 check_box ' >
                                                <div className="heading za_shift">
                                                    <span className='text font-m fs-9 text-white'>{`Shift ${index + 1}`}</span>
                                                </div>
                                            </div>

                                            <div className="align-items-center input_field-bg-clr col-md-11">
                                                <div className="time_slot  ">
                                                    <div className='col-md-4 d-flex  gap-2 me-1'>
                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.SunStartTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='SunStartTime'
                                                                name='SunStartTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SunStartTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            >
                                                                {TotalTimeArray?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='SunStartTime'
                                                                name='SunStartTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SunStartTime}
                                                                data={TotalTimeArray}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.SunStartTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.SunStartTime} */}
                                                        </div>

                                                        <div className={`col-md-6 input ar-multiple-br ${ScheduleShiftValidation?.[index]?.SunEndTime ? 'error' : ''}`}>
                                                            {/* <select className="form-control"
                                                                id='SunEndTime'
                                                                name='SunEndTime'
                                                                value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SunEndTime}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                            > */}
                                                            {/* {TotalTimeArray?.map((item) => {
                                                        return (
                                                            <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                        )
                                                    })} */}
                                                            {/* <option value=""></option>
                                                                {TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SunStartTime, item?.value);
                                                                })?.map((item) => {
                                                                    return (
                                                                        <option value={item?.value} className='text fs-12'>{item?.display}</option>
                                                                    )
                                                                })}
                                                            </select> */}
                                                            <SuperSearchList
                                                                type="client"
                                                                id='SunEndTime'
                                                                name='SunEndTime'
                                                                searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SunEndTime}
                                                                data={TotalTimeArray.filter((item) => {
                                                                    return compareTimes(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SunStartTime, item?.value);
                                                                })}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                                getSelectedData={handleScheduleShiftsSelectedData}
                                                                // is={is}
                                                                index={index}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn'
                                                                sup_inp='superSearchVisitInp'
                                                                className="form-control rounded"
                                                                inputError={ScheduleShiftValidation?.[index]?.SunEndTime ? true : false}
                                                            />
                                                            {/* {ScheduleShiftValidation?.[index]?.SunEndTime} */}
                                                        </div>

                                                    </div>

                                                    <div className='col-md-1 check_box ms-2'>
                                                        <div className="custom_check_box ">
                                                            <input type="checkbox"
                                                                className='align-self-center form-check-input p-0'
                                                                id="SunChecked"
                                                                name="SunChecked"
                                                                checked={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SunChecked}
                                                                // checked={mainModalMasterWeekSchedule?.Auth?.TueChecked}
                                                                onChange={(e) => handleOnChangeScheduleShifts(e, index, true)}
                                                            />
                                                        </div>
                                                    </div>



                                                    <div className={`col-md-2 input ar-multiple-br w-17 ${ScheduleShiftValidation?.[index]?.SunCaregiverID ? 'error' : ''}`}>

                                                        {/* <select className="form-control "
                                                            id='SunCaregiverID'
                                                            name='SunCaregiverID'
                                                            value={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SunCaregiverID}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e, index)}
                                                        >
                                                            {CareGiverDD?.map((CG) => {
                                                                return (
                                                                    <>
                                                                        <option value={CG?.value}>{CG?.display}</option>
                                                                    </>
                                                                )
                                                            })}
                                                        </select> */}
                                                        <SuperSearchList
                                                            type="client"
                                                            id='SunCaregiverID'
                                                            name='SunCaregiverID'
                                                            searchValue={mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.SunCareGiver}
                                                            data={CareGiverDD}
                                                            onChange={(e) => handleOnChangeScheduleShifts(e)}
                                                            getSelectedData={handleScheduleShiftsSelectedData}
                                                            // is={is}
                                                            index={index}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                            className="form-control rounded"
                                                        />
                                                        {/* {ScheduleShiftValidation?.[index]?.SunCaregiverID} */}
                                                    </div>
                                                    {/* <div className='col-md-6'>
                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                <p className='text font-m fs-11'>{item['Sun']}</p>
                                                                {!ViewMode && <button className='btn text font-m fs-12 text-decoration-underline za-red-clr' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Sun")}>Delete</button>}
                                                            </div>

                                                        </div> */}
                                                    <div className='col-md-5 ps-1-5'>
                                                        <div className='d-flex align-items-center  ps-2px gap-2'>
                                                            {/* <p className='text font-m fs-11 text-nowrap'>Approved: {item['Sun'] || 0.00} | Scheduled: 0 | Unscheduled: 0</p> */}
                                                            <p className='text font-m fs-11 text-nowrap'>Approved: {Math.abs(item['Sun']) || 0}
                                                                {AuthSearched && practiceType === "Adult Day Care" ? (
                                                                    !isNull(scheduledShiftsUnits?.[index]?.Sun?.scheduled) && (
                                                                        <> | Scheduled: {scheduledShiftsUnits?.[index]?.Sun?.scheduled}</>
                                                                    )
                                                                ) : (
                                                                    <>
                                                                        {/* General Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Sun?.scheduled) && (
                                                                            <> | Scheduled: {scheduledShiftsUnits?.[index]?.Sun?.scheduled}</>
                                                                        )}

                                                                        {/* Over Scheduled Display */}
                                                                        {!isNull(scheduledShiftsUnits?.[index]?.Sun?.overScheduled) ? (
                                                                            <> | Over Scheduled: {scheduledShiftsUnits?.[index]?.Sun?.overScheduled}</>
                                                                        ) : (
                                                                            /* Under Scheduled Display */
                                                                            !isNull(scheduledShiftsUnits?.[index]?.Sun?.underScheduled) && (
                                                                                <> | Under Scheduled: {scheduledShiftsUnits?.[index]?.Sun?.underScheduled}</>
                                                                            )
                                                                        )}
                                                                    </>
                                                                )}
                                                            </p>
                                                            {/* <i className='icon-delete fs-11 text-danger' onClick={() => handleDelete(mainModalMasterWeekSchedule?.Auth?.Shifts[index]?.ScheduleAdditionalShiftsID, "Sun")}></i> */}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light ar_footer justify-content-between">

                {AuthSearched ?

                    practiceType === "Adult Day Care" ?
                        IsRecordExist ?
                            !ViewMode ?
                                <div className='d-flex align-items-center gap-1 paragraph'>
                                    <i className='icon-Vector13 fs-14'></i>
                                    <p className='text fs-11 fst-italic'>This service code doesn't require time, you can use the default time <span className='za-blue-clr text-decoration-underline cursor-pointer' onClick={(e) => handleTimeInADC(e, '10:00 AM', '12:00 PM')}>10:00 AM to 12:00 PM</span></p>
                                </div>
                                : <div></div>
                            :
                            <div className='d-flex align-items-center gap-1 paragraph'>
                                <i className='icon-Vector13 fs-14'></i>
                                <p className='text fs-11 fst-italic'>This service code doesn't require time, you can use the default time <span className='za-blue-clr text-decoration-underline cursor-pointer' onClick={(e) => handleTimeInADC(e, '10:00 AM', '12:00 PM')}>10:00 AM to 12:00 PM</span></p>
                            </div>
                        : IsRecordExist ?
                            <div className='d-flex align-items-center gap-1 paragraph'>
                                <i className='icon-Vector13 fs-14'></i>
                                <p className='text fs-11 fst-italic'>Only New and Scheduled visits can be modified or deleted</p >
                            </div>
                            :
                            <div></div>
                    :
                    <div></div>}

                <div className="text-end">
                    <div className="btns-group">
                        <button className="btn btn-outline px-10 h-100 dark-clr" onClick={() => isSaved ? onCloseSave() : onClose()}>
                            Cancel
                        </button>
                        <button className="btn btn-validate px-10 h-100" onClick={() => handleSaveMasterWeek()}>Update</button>
                    </div>

                </div>
            </div>
        </Modal>

    )
}

export default AddMasterWeek
